import React, { useEffect, useState } from "react";
import Select, { components } from "react-select";
import 'react-datepicker/dist/react-datepicker.css';
import { Link, useLocation, useNavigate } from "react-router-dom";
// import PaymentTabs from './../PaymentGateway/PaymentTabs';
// import confirmicon from '../../assets/images/confirmicon.png';
// import ShippingAddrModel from "../../components/ShippingAddrModel";
import { useTranslation } from 'react-i18next';
import PlusIcon from "Ecommerce/template_three/assets/icons/PlusIcon";
import MinusIcon from "Ecommerce/template_three/assets/icons/MinusIcon";
import { Nationality } from "pos/common/module/nationalityarray";
import LeftSideArrowIcon from "Ecommerce/template_three/assets/icons/LeftSideArrowIcon";
import { _Api, _Apiauth } from "Ecommerce/common/api";
import EditIcon from "Ecommerce/template_three/assets/icons/EditIcon";
import ConfirmPage from "./ConfirmPage";
import OrderSummery from "./OrderSummery";
import './shipping.scss';
import DefaultImage from "Ecommerce/common/images/emptyCart.png"
import LeftArrow from "Ecommerce/common/icons/LeftArrow";
import CheckoutBucketIcon from "Ecommerce/common/icons/CheckoutBucketIcon";
import DownArrow from "Ecommerce/template_three/assets/icons/DownArrow";
import { toFormatPrice } from "Ecommerce/common/Formateprice";
import RightArrow from "admin/common/icons/right-arrow";
import PaymentTabs from "../PaymentGateway/PaymentTabs";
export default function Shipping(props) {

    const { ValueContainer, Placeholder } = components;
    const { t } = useTranslation();
    const accessToken = localStorage.getItem("ecomaccesstoken");
    const navigate = useNavigate();
    const [privacyPolicy, setPrivacyPolicy] = useState(false);
    const [activeAddress, setActiveAddress] = useState({billing: null, shipping:null})
    let cartdata = JSON.parse(localStorage.getItem('CartItems'))
    const { setOpenmodal } = props;
    const [nationalityoption, setNationalityoption] = useState();
    const [paytime, setpaytime] = useState('-');
    useEffect(() => {
        if (Nationality?.length) {
            let Nationalitydata = []
            Nationality.forEach((result) => {
                Nationalitydata.push({ value: result, label: result })
            })
            setNationalityoption(Nationalitydata)
        }
        if(accessToken){
            getaddress();
        }
    }, [])
    let gender = ["Male", "Female", "Other"]
    const { state } = useLocation()
    const idProofOption = [
        {
            value: "Passport",
            label: "Passport",
        },
        {
            value: "Driving License",
            label: "Driving License",
        },
        {
            value: "Citizen ID",
            label: "Citizen ID",
        },
    ];
    const [userdata, setUserdata] = useState({
        shipping_address: { 
            'fname': '',
            'lname': '',
            'nationality': '',
            'title': '',
            'govt_ids': [{ 'idtype': '', 'idnumber': '' }],
            'age': '',
            "contacts": [{ icon: 1, phoneCode: "", number: "" }],
            'gender': '',
            'address': '',
            'country': '',
            'state': '',
            'city': '',
            'zipcode': '',
            'emails': [""],
            "is_default": 0,
            "company":""
        },
        'default_billing': false,
        'agree': 0,
        'shipping_method': { 'shiptohome': '', 'storepick': '' },
        'billingaddress': {
            "company":"",
            'fname': '', 'lname': '', 'address': '', 'country': '', 'state': '', 'city': '', 'zipcode': '',
            'contacts': [{ icon: 1, phoneCode: "", number: "" }], 'emails': [],
            "is_default": 0
        }
    });

    const [dobvalues, setDobvalues] = useState({ date: [], month: [], year: [] })
    const [shipaddress, setShipaddress] = useState({ ship: false, billing: false })
    const [fromstaps, setFromstaps] = useState({ one: true, two: false, three: false })
    const [countrylist, setCountrylist] = useState([]);
    const [phonecodelist, setPhonecodelist] = useState([]);
    const [changeshipping, setChangeshipping] = useState(true);
    const [shippingmethod, setShippingmethod] = useState();
    const [errormessage, setErrormessage] = useState();
    const [shippinglist, setShippinglist] = useState([])
    const [shippingdata, setShippingdata] = useState();
    const [addNewAddress, setAddNewAddress] = useState('');
    const [fromshow, setFromshow] = useState(true)
    const [billingaddressfrom, setBillingaddress] = useState(false)
    const [paymentgetwaydata, setPaymentgetwaydata] = useState([])
    const [paymentdata, setPaymentdata] = useState({ Bank: [], Credit_Card: [] })
    const [lodaer, setLodaer] = useState(false)
    const [widtth, setWidtth] = useState(window.innerWidth);
    const [ addressdata ,setAddressdata] = useState();
    const [billingaddressdata, setBillingaddressdata] = useState(
        {
            'contacts': [{ icon: 1, phoneCode: "", number: "" }],
            'emails': [],
            is_default: 0
        }

    )
    const [creditpaymentdata, setCreditpaymentdata] = useState({
        message: "",
        payment: false,
        submitdata: false,
        Paymentmethod_type: "",
        payment_slag: "",
        PaymentMethod_id: "",
        PaymentMethod: ""
    })
    const [lastpagedata, setLastpagedata] = useState();
    const [isOpenOrder, setIsOpenOrder] = useState(false);

    // get screen width
    useEffect(() => {
        const handleResize = () => {
            setWidtth(window.innerWidth);
        };

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const getaddress = async () => {
        try {
            let postdata = {}
            let res = await _Api(postdata, `account/getAddresses`)
            if (res?.statusCode === 200) {
                setAddressdata(res?.data)
                // setAddressdata([])
            }
        }
        catch (err) {
            console.log(err, "err")
        }
    }


    const getFullAddress = async (UDID,billing = true) => {
        if(accessToken && UDID){
            try{
                let postdata = {
                    billing_address:billing,
                    id: UDID
                }
                let res = await _Api(postdata, `account/getAddressByID`)
                if (res?.statusCode === 200) {
                    console.log('this is the billing address',billing,res)
                    // setUserdata((state) =>{ {...state , billingaddress:{...res?.data}}})
                    delete res?.data?.primary;
                  if(res?.data && billing){
                    setUserdata((state) => ({
                        ...state,
                        billingaddress: {
                            ...res?.data
                        }
                    }))}

                    if(res?.data && !billing){
                        setUserdata((state) => ({
                            ...state,
                            shipping_address: {
                                ...res?.data
                            }
                        }))}
                }
            }
            catch (err) {
                console.log(err, "err")
            }
        }
    }


    const toggleOrderSummary = () => {
        setIsOpenOrder(!isOpenOrder);
    };
    const shippingitem = async () => {
        try {
            let cartids = state?.checkoutItems;
            // if (state?.checkoutItems?.length) {
            //     state.checkoutItems.map((result) => {
            //         let itemdata = localItems?.filter((cartitem) => cartitem.id === result?.id);
            //         if (itemdata?.[0]?.diamonddetails) {
            //             cartids.push({
            //                 "id": itemdata?.[0]?.id,
            //                 "qty": itemdata?.[0]?.qty,
            //                 "diamond_id": itemdata?.[0]?.diamonddetails?.diamonddata?.id,
            //                 "diamond_note": itemdata?.[0]?.diamonddetails?.diamonddata?.note,
            //                 "metal": itemdata?.[0]?.diamonddetails?.productdiamond?.metal?.value,
            //                 "shape": itemdata?.[0]?.diamonddetails?.productdiamond?.shape?.shapeId,
            //                 "size": itemdata?.[0]?.diamonddetails?.productdiamond?.size?._id,
            //                 "stone": itemdata?.[0]?.diamonddetails?.productdiamond?.stone?.value,
            //                 "pointer": itemdata?.[0]?.diamonddetails?.productdiamond?.pointer?.label,
            //                 "temp_cart_id": itemdata?.[0]?.temp_cart_id,
            //                 "custom_design": {
            //                     "engraving_text": itemdata?.[0]?.custom_design?.customizeText,
            //                     "side": itemdata?.[0]?.custom_design?.inorout,
            //                     "engraving_position": itemdata?.[0]?.custom_design?.textposition?.label,
            //                     "engraving_logo": itemdata?.[0]?.custom_design?.imageFile,
            //                     "font": itemdata?.[0]?.custom_design?.fonts?.label,
            //                     "logo_position": itemdata?.[0]?.custom_design?.imgPosition?.label
            //                 },
            //             })
            //         } else {
            //             cartids.push(itemdata[0])
            //         }
            //         return true;
            //     });
            // }
            let postdata = {
                diamond_ids: cartids
            }
            console.log(postdata, "Check cart ids")
            let res = await _Api(postdata, `order/getCartDetails`)
            if (res?.statusCode === 200) {
                if (res?.data) {
                    let array = [...res?.data];
                    array?.forEach((result) => {
                        result.qty = parseInt(state?.checkoutItems.filter(e => e?.id === result?.id)[0]['qty']);
                    })
                    setShippinglist(array)
                }

                setShippingdata((state) => ({
                    ...state,
                    CURRENCY: res?.CURRENCY
                }))
                if (res?.deleted_ids?.length) {
                    state?.checkoutItems.forEach((result) => {
                        if (!res?.deleted_ids.includes(result?.id)) {
                            let data = []
                            data.push(result)
                            localStorage.setItem('CartItems', JSON.stringify(data));
                        }
                    })
                }
            }
        }
        catch (err) {
            console.log(err, "Err")
        }
    }
    const callAge = (e) => {
        const current = new Date();
        const year = current.getFullYear();
        const calage = year - e.value;
        setUserdata((state) => ({
            ...state,
            shipping_address: {
                ...state?.shipping_address,
                age: calage
            }
        }))
    };

    const titleoption = [
        {
            value: "Mr",
            label: t("Mr."),
        },
        {
            value: "Miss",
            label: t("Miss"),
        },
        {
            value: "Mrs",
            label: t("Mrs"),
        },
        {
            value: "Ms",
            label: t("Ms"),
        },
    ];

    useEffect(() => {
        if (state?.checkoutItems?.length) {
            shippingitem()
        }
        // eslint-disable-next-line
    }, [state])

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            if (file.type.startsWith("image/")) {
                const reader = new FileReader();
                reader.onloadend = async () => {
                    try {
                        const postdata = {
                            image: reader.result,
                        };
                        let res = await _Api(postdata, `redis/uplaod`)
                        if (res.statusCode === 200) {
                            if (userdata?.paymentMethod?.IB) {
                                setUserdata({
                                    ...userdata,
                                    'paymentMethod': {
                                        ...userdata?.paymentMethod,
                                        IB: {
                                            ...userdata?.paymentMethod?.IB,
                                            image: res?.url
                                        }
                                    }
                                });
                            }
                            setErrormessage((state) => ({
                                ...state,
                                'bankimage': 'image is successfully upload'
                            }))
                        }
                    }
                    catch (err) {
                        console.log(err, "err")
                    }
                };
                if (file) {
                    reader?.readAsDataURL(file);
                }
            } else {
                alert("Please select a valid image file.");
            }
        }
    };
    const getuserdetails = async (monthoption) => {
        try {
            setErrormessage();
            let res = await _Api({}, `checkout/accountDetails`)
            if (res?.statusCode === 200) {
                if (res?.billingAddress) {
                    setBillingaddress(true)
                }
                setUserdata({
                    customer_id: res?.user?._id ? res?.user?._id : "",
                    shipping_address: {
                        fname: res?.shippingAddress?.fname ? res?.shippingAddress?.fname : res?.user?.fname,
                        mname: res?.shippingAddress?.mname ? res?.shippingAddress?.mname : res?.user?.mname,
                        lname: res?.shippingAddress?.lname ? res?.shippingAddress?.lname : res?.user?.lname,
                        nationality: res?.shippingAddress?.nationality,
                        title: res?.shippingAddress?.title,
                        govt_ids: res?.shippingAddress?.govt_ids?.length ? res?.shippingAddress?.govt_ids : [{ 'idtype': '', 'idnumber': '' }],
                        date_of_birth: {
                            date: res?.shippingAddress?.date_of_birth?.date,
                            month: monthoption.find(element => element?.value === res?.shippingAddress?.date_of_birth?.month), year: res?.shippingAddress?.date_of_birth?.year
                        },
                        age: res?.shippingAddress?.age,
                        gender: res?.shippingAddress?.gender,
                        address: res?.shippingAddress?.address,
                        country: res?.shippingAddress?.country ? res?.shippingAddress?.country : '',
                        state: res?.shippingAddress?.state,
                        city: res?.shippingAddress?.city,
                        zipcode: res?.shippingAddress?.zipcode,
                        contacts: res?.shippingAddress?.contacts?.length ? res?.shippingAddress?.contacts : [{ "icon": 1, "phoneCode": "", "number": "" }],
                        emails: res?.shippingAddress?.emails?.length ? res?.shippingAddress?.emails : [res?.user?.email],
                        UDID: res?.shippingAddress?.UDID,
                        is_default: res?.shippingAddress?.is_default ? res?.shippingAddress?.is_default : 0,
                    },
                    
                    billingaddress: {
                        'fname': res?.billingAddress?.fname ? res?.billingAddress?.fname : res?.user?.fname,
                        'lname': res?.billingAddress?.lname ? res?.billingAddress?.lname : res?.user?.lname,
                        'address': res?.billingAddress?.address ? res?.billingAddress?.address : "",
                        'country': res?.billingAddress?.country ? res?.billingAddress?.country : "",
                        'state': res?.billingAddress?.state ? res?.billingAddress?.state : "",
                        'city': res?.billingAddress?.city ? res?.billingAddress?.city : "",
                        'zipcode': res?.billingAddress?.zipcode ? res?.billingAddress?.zipcode : "",
                        'contacts': res?.billingAddress?.contacts?.length ? res?.billingAddress?.contacts : [{ icon: 1, phoneCode: "", number: "" }],
                        'emails': res?.billingAddress?.emails?.length ? res?.billingAddress?.emails : [res?.user?.email],
                        "govt_ids": res?.billingAddress?.govt_ids,
                        "is_default": res?.billingAddress?.is_default ? res?.billingAddress?.is_default : 0,
                        "UDID": res?.billingAddress?.UDID,
                        "date_of_birth": res?.billingAddress?.date_of_birth
                    }
                })
                setBillingaddressdata({
                    'fname': res?.billingAddress?.fname ? res?.billingAddress?.fname : res?.user?.fname,
                    'lname': res?.billingAddress?.lname ? res?.billingAddress?.lname : res?.user?.lname,
                    'address': res?.billingAddress?.address,
                    'country': res?.billingAddress?.country,
                    'state': res?.billingAddress?.state,
                    'city': res?.billingAddress?.city,
                    'zipcode': res?.billingAddress?.zipcode,
                    'contacts': res?.billingAddress?.contacts?.length ? res?.billingAddress?.contacts : [{ icon: 1, phoneCode: "", number: "" }],
                    'emails': res?.billingAddress?.emails?.length ? res?.billingAddress?.emails : [res?.user?.email],
                    "govt_ids": res?.billingAddress?.govt_ids,
                    "is_default": res?.billingAddress?.is_default ? res?.billingAddress?.is_default : 0,
                    "UDID": res?.billingAddress?.UDID,
                    "date_of_birth": res?.billingAddress?.date_of_birth
                })
            }
        }
        catch (err) {
            console.log(err, "err")
        }
    }
    const ChangeMultipleSelect = (first, key, label, second,forshipping=true) => {
        if(forshipping){

        
        if (label === 'govt_ids') {
            const ids = [...userdata?.shipping_address?.govt_ids];
            ids[key] = { 'idtype': first, 'idnumber': second }
            setUserdata({ ...userdata, 'shipping_address': { ...userdata?.shipping_address, govt_ids: ids } });
        }
        if (label === 'contacts') {
            const contacts = [...userdata?.shipping_address?.contacts];
            contacts[key] = { "icon": 1, 'phoneCode': first, 'number': second }
            setUserdata({ ...userdata, 'shipping_address': { ...userdata?.shipping_address, contacts: contacts } });
        }
        if (label === 'email') {
            const email = [...userdata?.shipping_address?.emails];
            email[key] = first;
            setUserdata({ ...userdata, 'shipping_address': { ...userdata?.shipping_address, emails: email } });
        }
    }else{
        if (label === 'govt_ids') {
            const ids = [...userdata?.billingaddress?.govt_ids];
            ids[key] = { 'idtype': first, 'idnumber': second }
            setUserdata({ ...userdata, 'billingaddress': { ...userdata?.billingaddress, govt_ids: ids } });
        }
        if (label === 'contacts') {
            const contacts = [...userdata?.billingaddress?.contacts];
            contacts[key] = { "icon": 1, 'phoneCode': first, 'number': second }
            setUserdata({ ...userdata, 'billingaddress': { ...userdata?.billingaddress, contacts: contacts } });
        }
        if (label === 'email') {
            const email = [...userdata?.billingaddress?.emails];
            email[key] = first;
            setUserdata({ ...userdata, 'billingaddress': { ...userdata?.billingaddress, emails: email } });
        }
    }
    }
    const AddRow = (element,forshipping=true) => {
        if(forshipping){
        if (element === 'govt_ids') {
            const ids = [...userdata?.shipping_address?.govt_ids];
            ids.push({ 'idtype': '', 'idnumber': '' });
            setUserdata({ ...userdata, 'shipping_address': { ...userdata?.shipping_address, govt_ids: ids } });

        }
        if (element === 'contacts') {
            const contacts = [...userdata?.shipping_address?.contacts];
            contacts.push({ "icon": 1, "phoneCode": "", "number": "" });
            setUserdata({ ...userdata, 'shipping_address': { ...userdata?.shipping_address, contacts: contacts } });

        }
        if (element === 'email') {
            const email = [...userdata?.shipping_address?.emails];
            email.push('');
            setUserdata({ ...userdata, 'shipping_address': { ...userdata?.shipping_address, emails: email } });

        }
    }else{
        if (element === 'govt_ids') {
            const ids = [...userdata?.billingaddress?.govt_ids];
            ids.push({ 'idtype': '', 'idnumber': '' });
            setUserdata({ ...userdata, 'billingaddress': { ...userdata?.billingaddress, govt_ids: ids } });

        }
        if (element === 'contacts') {
            const contacts = [...userdata?.billingaddress?.contacts];
            contacts.push({ "icon": 1, "phoneCode": "", "number": "" });
            setUserdata({ ...userdata, 'billingaddress': { ...userdata?.billingaddress, contacts: contacts } });

        }
        if (element === 'email') {
            const email = [...userdata?.shipping_address?.emails];
            email.push('');
            setUserdata({ ...userdata, 'billingaddress': { ...userdata?.billingaddress, emails: email } });

        }
    }
    }
    // const removebillingblock = (element ,key)=>{
    //     if (element === 'contacts') {
    //         let contacts = [...userdata?.shipping_address?.contacts];
    //         contacts = contacts.filter((e, s) => s !== key);
    //         setUserdata({ ...userdata, 'shipping_address': { ...userdata?.shipping_address, contacts: contacts } });
    //     }
    // }
    const RemoveBlock = (element, key,forshipping=true) => {
        if(forshipping){
        if (element === 'govt_ids') {
            let ids = [...userdata?.shipping_address?.govt_ids];
            ids = ids.filter((e, s) => s !== key);
            setUserdata({ ...userdata, 'shipping_address': { ...userdata?.shipping_address, govt_ids: ids } });

        }
        if (element === 'contacts') {
            let contacts = [...userdata?.shipping_address?.contacts];
            contacts = contacts.filter((e, s) => s !== key);
            setUserdata({ ...userdata, 'shipping_address': { ...userdata?.shipping_address, contacts: contacts } });
        }
        if (element === 'email') {
            let email = [...userdata?.shipping_address?.emails];
            email = email.filter((e, s) => s !== key);
            setUserdata({ ...userdata, 'shipping_address': { ...userdata?.shipping_address, emails: email } });
        }
    }else{
        if (element === 'govt_ids') {
            let ids = [...userdata?.billingaddress?.govt_ids];
            ids = ids.filter((e, s) => s !== key);
            setUserdata({ ...userdata, 'billingaddress': { ...userdata?.billingaddress, govt_ids: ids } });

        }
        if (element === 'contacts') {
            let contacts = [...userdata?.billingaddress?.contacts];
            contacts = contacts.filter((e, s) => s !== key);
            setUserdata({ ...userdata, 'billingaddress': { ...userdata?.billingaddress, contacts: contacts } });
        }
        if (element === 'email') {
            let email = [...userdata?.billingaddress?.emails];
            email = email.filter((e, s) => s !== key);
            setUserdata({ ...userdata, 'billingaddress': { ...userdata?.billingaddress, emails: email } });
        }
    }
    }
    const getcountry = async () => {
        try {
            let res = await _Apiauth({}, `redis/countryList`)
            if (res?.statusCode === 200) {
                if (res?.data) {
                    let array = [];
                    let phoncodearray = [];
                    res?.data.forEach((result) => {
                        array.push({ 'label': result?.name, 'value': result?.id });
                        phoncodearray.push({ 'label': result?.phoneCode, 'value': result?.phoneCode })
                    })
                    setCountrylist(array);
                    setPhonecodelist(phoncodearray);
                }

            }
        }
        catch (err) {
            console.log(err, "err")
        }
    }
    const getshippings = async () => {
        try {
            let res = await _Apiauth({}, `redis/shipingMathod`)
            if (res?.statusCode === 200) {
                setShippingmethod({ shiptohome: res?.ShipToHome, storepickup: res?.StorePickup });
            } else {
                setShippingmethod({ shiptohome: [], storepickup: [] });
            }
        }
        catch (err) {
            console.log(err, "err")
        }
    }
    const ChangeCheck = (label, e) => {
        if (label === 'agree') {
            if (e.target.checked) {
                setUserdata({ ...userdata, 'agree': 1 });
            } else {
                setUserdata({ ...userdata, 'agree': 0 });
            }
        }
        if (label === 'default_billing') {
            if (e.target.checked) {
                setUserdata({
                    ...userdata,
                    'billingaddress': userdata?.shipping_address,
                    default_billing: true
                });

            } else {
                setUserdata({
                    ...userdata,
                    'billingaddress': billingaddressdata,
                    default_billing: false
                });
            }
        }
    }
    const handleSelectAddress = (address,key) =>{
        // console.log(activeAddress, "activ address" ,address)
        // setUserdata((state)=>({...state, billingaddress: address })); 
        getFullAddress(address?.UDID )
        setActiveAddress((state)=>({...state, billing : key}))
    }
    const validationfun = (userdata) => {
        console.log(userdata, "checkuserdata")
        let passval = true;
        
        if(!privacyPolicy){
            setErrormessage((state)=>({
                ...state,
                'privacyPolicy' : 'Please confirm Privacy Policy'
            }))
            passval = false;
        } else {
            setErrormessage((state) => ({
                ...state,
                'privacyPolicy': ''
            }))
        }
        if(!addressdata?.shipping_address?.length){
        if (!userdata?.shipping_address?.fname) {
            setErrormessage((state) => ({
                ...state,
                'fname': 'First Name is required'
            }))
            passval = false;
        } else {
            setErrormessage((state) => ({
                ...state,
                'fname': ''
            }))
        }
        if (!userdata?.shipping_address?.lname) {
            setErrormessage((state) => ({
                ...state,
                'lname': 'Last Name is required'
            }))
            passval = false;
        } else {
            setErrormessage((state) => ({
                ...state,
                'lname': ''
            }))
        }
        // if (!userdata?.shipping_address?.nationality) {
        //     setErrormessage((state) => ({
        //         ...state,
        //         'nationality': 'Nationality is required'
        //     }))
        //     passval = false;
        // } else {
        //     setErrormessage((state) => ({
        //         ...state,
        //         'nationality': ''
        //     }))
        // }
        // if (!userdata?.shipping_address?.title) {
        //     setErrormessage((state) => ({
        //         ...state,
        //         'title': 'Title is required'
        //     }))
        //     passval = false;
        // } else {
        //     setErrormessage((state) => ({
        //         ...state,
        //         'title': ''
        //     }))
        // }
        // if (!userdata?.shipping_address?.govt_ids[0]?.idnumber || !userdata?.shipping_address?.govt_ids[0]?.idtype) {
        //     setErrormessage((state) => ({
        //         ...state,
        //         'govt_ids': 'Id Proof is required'
        //     }))
        //     passval = false;
        // } else {
        //     setErrormessage((state) => ({
        //         ...state,
        //         'govt_ids': ''
        //     }))
        // }
        // if (!userdata?.shipping_address?.date_of_birth?.date || !userdata?.shipping_address?.date_of_birth?.month?.value || !userdata?.shipping_address?.date_of_birth?.year) {
        //     setErrormessage((state) => ({
        //         ...state,
        //         'date_of_birth': 'Date of birth is required'
        //     }))
        //     passval = false;
        // } else {
        //     setErrormessage((state) => ({
        //         ...state,
        //         'date_of_birth': ''
        //     }))
        // }
        // if (!userdata?.shipping_address?.age) {
        //     setErrormessage((state) => ({
        //         ...state,
        //         'age': 'Age is required'
        //     }))
        //     passval = false;
        // } else {
        //     setErrormessage((state) => ({
        //         ...state,
        //         'age': ''
        //     }))
        // }
        // if (!userdata?.shipping_address?.gender) {
        //     setErrormessage((state) => ({
        //         ...state,
        //         'gender': 'Gender is required'
        //     }))
        //     passval = false;
        // } else {
        //     setErrormessage((state) => ({
        //         ...state,
        //         'gender': ''
        //     }))
        // }
        if (!userdata?.shipping_address?.address) {
            setErrormessage((state) => ({
                ...state,
                'address': 'Address is required'
            }))
            passval = false;
        } else {
            setErrormessage((state) => ({
                ...state,
                'address': ''
            }))
        }
        if (!userdata?.shipping_address?.country?.value) {
            setErrormessage((state) => ({
                ...state,
                'country': 'Country is required'
            }))
            passval = false;
        } else {
            setErrormessage((state) => ({
                ...state,
                'country': ''
            }))
        }
        if (!userdata?.shipping_address?.state) {
            setErrormessage((state) => ({
                ...state,
                'state': 'State is required'
            }))
            passval = false;
        } else {
            setErrormessage((state) => ({
                ...state,
                'state': ''
            }))
        }
        if (!userdata?.shipping_address?.city) {
            setErrormessage((state) => ({
                ...state,
                'city': 'City is required'
            }))
            passval = false;
        } else {
            setErrormessage((state) => ({
                ...state,
                'city': ''
            }))
        }
        if (!userdata?.shipping_address?.zipcode) {
            setErrormessage((state) => ({
                ...state,
                'zipcode': 'Zipcode is required'
            }))
            passval = false;
        } else {
            setErrormessage((state) => ({
                ...state,
                'zipcode': ''
            }))
        }
        if (!userdata?.shipping_address?.emails[0]) {
            setErrormessage((state) => ({
                ...state,
                'emails': 'Emails is required'
            }))
            passval = false;
        } else if (!isValidEmail(userdata?.shipping_address?.emails[0])) {
            setErrormessage((state) => ({
                ...state,
                'emails': 'Invalid Email'
            }))
            passval = false;
        } else {
            setErrormessage((state) => ({
                ...state,
                'emails': ''
            }))
        }
        if (!userdata?.shipping_address?.contacts[0]?.phoneCode || !userdata?.shipping_address?.contacts[0]?.number) {
            setErrormessage((state) => ({
                ...state,
                'contacts': 'Contacts is required'
            }))
            passval = false;
        } else {
            setErrormessage((state) => ({
                ...state,
                'contacts': ''
            }))
        }
        }
        if (!passval) {
            setFromshow(true)
            return;
        }
        if (changeshipping) {
            if (!userdata?.shipping_method?.shiptohome) {
                setErrormessage((state) => ({
                    ...state,
                    'shipping_method': 'Shipping method is required'
                }))
                passval = false;
            } else {
                setErrormessage((state) => ({
                    ...state,
                    'shipping_method': ''
                }))
            }
        } else {
            if (!userdata?.shipping_method?.storepick) {
                setErrormessage((state) => ({
                    ...state,
                    'shipping_method': 'Shipping method is required'
                }))
                passval = false;
            } else {
                setErrormessage((state) => ({
                    ...state,
                    'shipping_method': ''
                }))
            }
        }
        if (passval) {
            setFromstaps({ one: false, two: true, three: false })
        }
    }
    const validationfunsecound = (userdata) => {
        let fromisvalid = true;

        if(!addressdata?.billingAddress?.length){
        if (!userdata?.billingaddress?.fname) {
            setErrormessage((state) => ({
                ...state,
                'billingfname': 'First Name is required'
            }))
            fromisvalid = false;
        } else {
            setErrormessage((state) => ({
                ...state,
                'billingfname': ''
            }))
        }
        if (!userdata?.billingaddress?.lname) {
            setErrormessage((state) => ({
                ...state,
                'billinglname': 'Last Name is required'
            }))
            fromisvalid = false;
        } else {
            setErrormessage((state) => ({
                ...state,
                'billinglname': ''
            }))
        }
        if (!userdata?.billingaddress?.address) {
            setErrormessage((state) => ({
                ...state,
                'billingaddress': 'Address is required'
            }))
            fromisvalid = false;
        } else {
            setErrormessage((state) => ({
                ...state,
                'billingaddress': ''
            }))
        }
        if (!userdata?.billingaddress?.country?.value) {
            setErrormessage((state) => ({
                ...state,
                'billingcountry': 'Country is required'
            }))
            fromisvalid = false;
        } else {
            setErrormessage((state) => ({
                ...state,
                'billingcountry': ''
            }))
        }
        if (!userdata?.billingaddress?.state) {
            setErrormessage((state) => ({
                ...state,
                'billingstate': 'State is required'
            }))
            fromisvalid = false;
        } else {
            setErrormessage((state) => ({
                ...state,
                'billingstate': ''
            }))
        }
        if (!userdata?.billingaddress?.city) {
            setErrormessage((state) => ({
                ...state,
                'billingcity': 'City is required'
            }))
            fromisvalid = false;
        } else {
            setErrormessage((state) => ({
                ...state,
                'billingcity': ''
            }))
        }
        if (!userdata?.billingaddress?.zipcode) {
            setErrormessage((state) => ({
                ...state,
                'billingzipcode': 'Zipcode is required'
            }))
            fromisvalid = false;
        } else {
            setErrormessage((state) => ({
                ...state,
                'billingzipcode': ''
            }))
        }
       
        if (!userdata?.billingaddress?.contacts[0].number) {
            setErrormessage((state) => ({
                ...state,
                'billingcontacts': 'Contacts is required'
            }))
            fromisvalid = false;
        } else {
            setErrormessage((state) => ({
                ...state,
                'billingcontacts': ''
            }))
        }
        if (!userdata?.billingaddress?.emails[0]) {
            setErrormessage((state) => ({
                ...state,
                'billingemails': 'Email is required'
            }))
            fromisvalid = false;
        } else if (!isValidEmail(userdata?.billingaddress?.emails[0])) {
            setErrormessage((state) => ({
                ...state,
                'billingemails': 'Invalid Email'
            }))
            fromisvalid = false;
        } else {
            setErrormessage((state) => ({
                ...state,
                'billingemails': ''
            }))
        }
        if (!fromisvalid) {
            setBillingaddress(false)
        }
        if (!userdata?.agree) {
            setErrormessage((state) => ({
                ...state,
                'privacy': 'Select privacy is required'
            }))
            fromisvalid = false;
        } else {
            setErrormessage((state) => ({
                ...state,
                'privacy': ''
            }))
        }
        console.log(creditpaymentdata, "check Paymentmethod_type");
        console.log(creditpaymentdata?.Paymentmethod_type, "check Paymentmethod_type");

        if (!creditpaymentdata?.Paymentmethod_type) {
            setErrormessage((state) => ({
                ...state,
                'payment': 'Pleace select payment method is required'
            }))
            fromisvalid = false;
        } else {
            if (creditpaymentdata?.Paymentmethod_type === "Bank" && creditpaymentdata?.payment_slag !== "paypal-payment" && creditpaymentdata?.payment_slag !== "cregis-payment") {
                if (!userdata?.paymentMethod?.IB?.name) {
                    setErrormessage((state) => ({
                        ...state,
                        'payment': 'Pleace select bank is required'
                    }))
                    fromisvalid = false;
                } else {
                    setErrormessage((state) => ({
                        ...state,
                        'payment': ''
                    }))
                }
                if (!userdata?.paymentMethod?.IB?.image) {
                    setErrormessage((state) => ({
                        ...state,
                        'payment': 'Upload evidence of transfer required'
                    }))
                    fromisvalid = false;
                } else {
                    setErrormessage((state) => ({
                        ...state,
                        'payment': ''
                    }))
                }
            }

            if (creditpaymentdata?.stripekey) {
                setUserdata((state) => ({
                    ...state,
                    paymentMethod: {
                        paymentID: creditpaymentdata?.stripekey,
                        paymentMethodId: creditpaymentdata?.PaymentMethod,
                    }
                }))
                
                fromisvalid = true;
            } else {
                setErrormessage((state) => ({
                    ...state,
                    'payment': creditpaymentdata?.message
                }))
                fromisvalid = false;
            }


        }
    }
        console.log(fromisvalid, "FinelSubmit", creditpaymentdata);
        if (fromisvalid) {
            setCreditpaymentdata((state) => ({
                ...state,
                submitdata: true
            }))
        }

    }


    const CompletedPaymentAndOrderAFterStepMove = async () => {
        setFromstaps({ one: false, two: false, three: true })
        let setupdatearray = [...state?.checkoutItems]
        const newArray1 = cartdata.filter((obj1) => !setupdatearray.some((obj2) => obj2.id === obj1.id));
        localStorage.setItem('CartItems', JSON.stringify(newArray1));
    }

    useEffect(() => {
        if (creditpaymentdata?.payment && creditpaymentdata?.payment_slag === "paypal-payment") {
            saveorder();
        }
        if (creditpaymentdata?.payment && creditpaymentdata?.payment_slag === "stripe-payment") {
            saveorder();
        }
        if (creditpaymentdata?.payment && creditpaymentdata?.payment_slag === "cregis-payment") {
            saveorder();
        }
        // eslint-disable-next-line
    }, [creditpaymentdata?.payment, creditpaymentdata?.payment_slag])


    const getpayment = async () => {
        try {
            let postdata = {}
            let res = await _Api(postdata, `checkout/get-payment`)
            if (res?.statusCode === 200) {
                setPaymentdata({
                    Bank: res?.data?.Bank ? res?.data?.Bank : [],
                    Credit_Card: res?.data?.Credit_Card ? res?.data?.Credit_Card : []
                })
                setPaymentgetwaydata(res?.paymetpaylist)
            }
        }
        catch (err) {
            console.log(err, "err")
        }
    }
    useEffect(() => {
        getcountry();
        getshippings();
        getpayment()
    }, []);

    useEffect(() => {
        console.log(addressdata, "address data here")
        const Dateoption = [...new Array(31)].map((each, index) => ({
            label: index + 1,
            value: index + 1,
        }));
        setDobvalues((state) => ({
            ...state,
            date: Dateoption
        }));
        const monthoption = [
            {
                value: 1,
                label: "JAN",
            },
            {
                value: 2,
                label: "FEB",
            },
            {
                value: 3,
                label: "MAR",
            },
            {
                value: 4,
                label: "APR",
            },
            {
                value: 5,
                label: "MAY",
            },
            {
                value: 6,
                label: "JUN",
            },
            {
                value: 7,
                label: "JUL",
            },
            {
                value: 8,
                label: "AUG",
            },
            {
                value: 9,
                label: "SEP",
            },
            {
                value: 10,
                label: "OCT",
            },
            {
                value: 11,
                label: "NOV",
            },
            {
                value: 12,
                label: "DEC",
            },

        ]
        setDobvalues((state) => ({
            ...state,
            month: monthoption
        }));
        const current = new Date();
        const lastyear = current.getFullYear() - 5;
        const firstyear = lastyear - 50;
        const yearoption = [...new Array(lastyear - firstyear + 2)]
            .fill()
            .map((_, idx) => ({ label: firstyear + idx, value: firstyear + idx }));
        setDobvalues((state) => ({
            ...state,
            year: yearoption
        }));
        if (accessToken) {
            getuserdetails(monthoption);
            setFromshow(false)
        }
        // eslint-disable-next-line
    }, []);


    const saveorder = async () => {

        let array = [...state?.checkoutItems]
        array.forEach((result) =>
            delete result?.price
        )
        let obj = { ...userdata }
        let usershipping_addressobj = { ...obj?.shipping_address }
        if (usershipping_addressobj?.date_of_birth?.month?.value) {
            usershipping_addressobj.date_of_birth.month = userdata?.shipping_address?.date_of_birth?.month?.value
        }
        let userbilling = { ...obj?.billingaddress }
        if (userbilling?.date_of_birth?.month?.value) {
            userbilling.date_of_birth.month = userdata?.billingaddress?.date_of_birth?.month?.value
        }
        usershipping_addressobj.country = userdata?.shipping_address?.country?.value
        userbilling.country = userdata?.billingaddress?.country?.value

        if (creditpaymentdata?.stripekey) {
            obj.paymentMethod = {
                paymentID: creditpaymentdata?.stripekey,
                paymentMethodId: creditpaymentdata?.PaymentMethod,
            }
        }
        setLodaer(true);
        console.log(array, "DEEPAK SAVE FORM");

        try {
            
            let postdata = {
                customer_id: obj?.customer_id ? obj?.customer_id : "",
                cart: array,
                shipping_method: obj?.shipping_method,
                shipping_address: usershipping_addressobj,
                paymentMethod: obj?.paymentMethod,
                default_billing: obj?.default_billing ? obj?.default_billing : false,
                billing_address: userbilling
            }
            let res = await _Api(postdata, `checkout/placeOrder`)
            if (res?.statusCode === 200) {
                setLastpagedata(res)
                // setShippinglist([])
                setLodaer(false)
                CompletedPaymentAndOrderAFterStepMove();
                // setCreditpaymentdata((state) => ({
                //     ...state,
                //     submitdata: true
                // }))
            } else {
                setErrormessage((state) => ({
                    ...state,
                    'ordererror': res?.message
                }))
                setLodaer(false)
            }
        }
        catch (err) {
            setLodaer(false)
            console.log(err, "err")
            setErrormessage((state) => ({
                ...state,
                'ordererror': err?.response?.data?.message,
            }))
        }
    }


    const isValidEmail = (email) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
        return emailRegex.test(email);
    };

    const CustomValueContainer = ({ children, ...props }) => {
        return (
            <ValueContainer {...props}>
                {React.Children.map(children, (child) =>
                    child && child.type !== Placeholder ? child : null
                )}
            </ValueContainer>
        );
    };

    const handlePrivacyPolicy = () => {
        setPrivacyPolicy(!privacyPolicy); 
        if(errormessage?.privacyPolicy && privacyPolicy){
             setErrormessage((state)=>({...state, privacyPolicy : '' })) 
            }
        }

    const CopyBillingAddresstoShippingAddress = (e) => {
        if(e.target.checked){
            console.log(userdata?.shipping_address, "both addresses", userdata?.billingaddress);
            setUserdata((state)=>({...state,  shipping_address : userdata?.billingaddress }))
        }
    }

  return (
    <>
            <div className="shippingpage ecommerce-main-layout-bodyContent">
                {state?.checkoutItems?.length ?
                    <>
                            <div className="shippingpage-title">
                                <span onClick={()=>navigate(-1)} className="cursor-pointer"><LeftArrow/></span><span>{("Back to Home")}</span>
                            </div>
                            <div className="shippingpage-subTitle">
                                <div className="shippingpage-subTitle-header cursor-pointer" onClick={()=>navigate(-1)}><CheckoutBucketIcon/> {t("Checkout")} </div>
                                <div className="shippingpage-subTitle-subheader">{t("Shipping, taxes, and discounts at checkout")}</div>
                            </div>
                        <div className="shippingpage-bothSideBox">
                            <form id="shippingStepform" className="shipping-step-mainForm">
                                <div className="shippingpage-bothSideBox-leftSide shipping">
                                <div className="shippingpage-subTitle responsive">
                                <div className="shippingpage-subTitle-header"><span className="rightarrow cursor-pointer" onClick={()=>navigate(-1)}><RightArrow/></span> <CheckoutBucketIcon/> {t("Checkout")} </div>
                                <div className="shippingpage-subTitle-subheader">{t("Shipping, taxes, and discounts at checkout")}</div>
                                </div>
                                
                                    <div className="navigation-lineBox">
                                        <ul className="navigation-lineBox-container" id="progressbar">
                                            <li className="position-relative" id="account">
                                                {/* {fromstaps?.two || fromstaps?.three ?
                                                    <div className="navigation-lineBox-container-firstStartBox">
                                                        <div className="com-nav-lineShow"></div>
                                                    </div> : */}
                                                    <div className="navigation-lineBox-container-firstStartBox active">
                                                        <span className="com-nav-lightPointer ">1</span>
                                                        <div className="com-nav-lineShow"></div>
                                                    </div>
                                                    {/* } */}
                                                <span className="navig-bottom-text active">{t("Billing Details")}</span>
                                            </li>
                                            <li className="position-relative" id="personal">
                                                {/* {fromstaps?.three ?
                                                    <div className={`navigation-lineBox-container-firstStartBox`}>
                                                        <img src={confirmicon} className="com-nav-lightPointer " alt="" />
                                                        <div className="com-nav-lineShow"></div>
                                                    </div> : */}
                                                    <div className={`navigation-lineBox-container-firstStartBox ${fromstaps?.two || fromstaps?.three ? "active" : ""}`}>
                                                        <span className="com-nav-lightPointer ">2</span>
                                                        <div className="com-nav-lineShow"></div>
                                                    </div>
                                                    {/* } */}

                                                <span className={`navig-bottom-text ${fromstaps?.two || fromstaps?.three ? 'active' : ''}`}>{t("Payment Option")}</span>
                                            </li>
                                            <li className="position-relative" id="payment">
                                                {/* {fromstaps?.three ?
                                                    <div className={`navigation-lineBox-container-firstStartBox`}>
                                                        <img src={confirmicon} className="com-nav-lightPointer " alt="" />
                                                        <div className="com-nav-lineShow"></div>
                                                    </div> : */}
                                                    <div className={`navigation-lineBox-container-firstStartBox ${fromstaps?.three ? "active" : ""} `}>
                                                        <span className="com-nav-lightPointer ">3</span>
                                                        <div className="com-nav-lineShow"></div>
                                                    </div>
                                                {/* } */}
                                                <span className={`navig-bottom-text ${fromstaps?.three ? 'active' : ''}`}>{t("Confirmation")}</span>
                                            </li>
                                        </ul>
                                        <div></div>
                                    </div>

                                    <div className="shipping-step-mainForm-Container">
                                        {fromstaps?.one ?
                                            <fieldset className="shipping-step-mainForm-Container-fieldsetBox">
                                                {/* {!accessToken ?
                                                    <div className="shipping-alertBox">
                                                        <p className="shipping-alertBox-paraAlert">{t("Already a member")}? <span
                                                            onClick={() => {
                                                                setOpenmodal(prevState => ({
                                                                    ...prevState,
                                                                    showLoginModel: true,
                                                                    showRegisterModel: false,
                                                                    showemailvarifymodal: false,
                                                                    forgetpassword: false,
                                                                    resetpassword: false,
                                                                    newpassword: false
                                                                }))
                                                            }}> {t("Sign-in")}</span> {t("for faster checkout")} </p>
                                                        <p className="shipping-alertBox-paraAlert">{t("Don’t have an account")}? <span
                                                            onClick={() => {
                                                                setOpenmodal(prevState => ({
                                                                    ...prevState,
                                                                    showLoginModel: false,
                                                                    showRegisterModel: true,
                                                                    showemailvarifymodal: false,
                                                                    forgetpassword: false,
                                                                    resetpassword: false,
                                                                    newpassword: false
                                                                }))
                                                            }}>{t("Create Account")}</span></p>
                                                    </div>
                                                    : ''} */}
                                                 
                                                <div className="shipping-addressFromBox">
                                                {shippingmethod?.shiptohome?.length || shippingmethod?.storepickup?.length ?
                                                        <div className="shipping-addressFromBox-shipngMethodBox">
                                                            <div className="shipping-addressFromBox-shipngMethodBox-headingMain">{t("Shipping Method")} ({t("Select 1 option")})</div>
                                                            {/* <div className="shipping-addressFromBox-shipngMethodBox-selectMethod">
                                                                {shippingmethod?.shiptohome?.length ?
                                                                    <div className="ecom-radiobtnShowBox">
                                                                        <input type="radio" onChange={() => setChangeshipping(true)} className="ecom-radiobtnShowBox-inputField" id="shipHome" name="shippingOption" checked={changeshipping ? true : false} />
                                                                        <label className="ecom-radiobtnShowBox-labeltext" htmlFor="shipHome">{t("Ship to home")}</label>
                                                                    </div>
                                                                    : ""}
                                                                {shippingmethod?.storepickup?.length ?
                                                                    <div className="ecom-radiobtnShowBox">
                                                                        <input type="radio" onChange={() => setChangeshipping(false)} className="ecom-radiobtnShowBox-inputField" id="storePickup" name="shippingOption" checked={!changeshipping ? true : false} />
                                                                        <label className="ecom-radiobtnShowBox-labeltext" htmlFor="storePickup">{t("Store Pickup")}</label>
                                                                    </div>
                                                                    : ""}
                                                            </div> */}
                                                            <div className="shipping-addressFromBox-shipngMethodBox-optionswrapper">
                                                            {shippingmethod?.shiptohome?.length ? shippingmethod?.shiptohome.map((result, key) => {
                                                                    return (
                                                                        <div className="shipping-addressFromBox-shipngMethodBox-homeDeliveryAddrBox" key={key}>
                                                                            <div className={`shipping-addressFromBox-shipngMethodBox-homeDeliveryAddrBox-selectStandard ${userdata?.shipping_method?.shiptohome === result?._id && changeshipping ? 'active' : ""}`} onClick={() => {
                                                                                 setChangeshipping(true);
                                                                                setUserdata({ ...userdata, shipping_method: { shiptohome: result?._id } }); setShippingdata((state) => ({
                                                                                    ...state,
                                                                                    shipprice: result?.price
                                                                                }));
                                                                            }}>
                                                                                <div className="shipping-addressFromBox-shipngMethodBox-homeDeliveryAddrBox-selectStandard-radioBox">
                                                                                    <div className="ecom-radiobtnShowBox" >
                                                                                        <input type="radio" className="ecom-radiobtnShowBox-inputField"
                                                                                            id={result?._id + key} name="ship2home"
                                                                                            checked={userdata?.shipping_method?.shiptohome === result?._id && changeshipping}
                                                                                        />
                                                                                        <label className="ecom-radiobtnShowBox-labeltext"
                                                                                            htmlFor={result?._id + key}></label>
                                                                                    </div>
                                                                                </div>
                                                                                <div
                                                                                    className="shipping-addressFromBox-shipngMethodBox-homeDeliveryAddrBox-selectStandard-shippDetailsBox">
                                                                                    <div className="standardShipping-Show">
                                                                                        <p className="standardShipping-Show-headingText">{t(`${result?.type}`)}</p>
                                                                                        <p className="standardShipping-Show-arrivesText">{t(`${result?.description}`)}</p>
                                                                                    </div>
                                                                                    <h2 className="shippingCostAmt">{result?.formatted_price}</h2>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    )
                                                                }) : ''}
                                                             <div className="shipping-addressFromBox-shipngMethodBox-homeDeliveryAddrBox" onClick={() => setChangeshipping(false)}>
                                                                            <div className={`shipping-addressFromBox-shipngMethodBox-homeDeliveryAddrBox-selectStandard ${!changeshipping ? 'active' : ""}`}>
                                                                                <div className="shipping-addressFromBox-shipngMethodBox-homeDeliveryAddrBox-selectStandard-radioBox">
                                                                                    <div className="ecom-radiobtnShowBox" >
                                                                                        <input type="radio" className="ecom-radiobtnShowBox-inputField"
                                                                                        
                                                                                        id="storePickup" 
                                                                                        name="shippingOption" 
                                                                                        checked={!changeshipping ? true : false}
                                                                                        />
                                                                                        <label className="ecom-radiobtnShowBox-labeltext"
                                                                                            htmlFor="storePickup"></label>
                                                                                    </div>
                                                                                </div>
                                                                                <div
                                                                                    className="shipping-addressFromBox-shipngMethodBox-homeDeliveryAddrBox-selectStandard-shippDetailsBox">
                                                                                    <div className="standardShipping-Show">
                                                                                        <p className="standardShipping-Show-headingText">{t(`Pickup from store`)}</p>
                                                                                        <p className="standardShipping-Show-arrivesText">{t(`Today`)}</p>
                                                                                    </div>
                                                                                    <h2 className="shippingCostAmt">{t("Free")}</h2>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                            </div>



                                                            {changeshipping ?
                                                               null
                                                                :

                                                                <div className="shippingAddresboxWrapCont">
                                                                    {shippingmethod?.storepickup?.length ? shippingmethod?.storepickup.map((result, key) => {
                                                                        const items = [];

                                                                        for (let key in result?.store_timeSchedule) {

                                                                            items.push(<> <div className="shipping-timeSetBox-singleDay" key={key}><p className="userShippAddressBox-contentBox-lightText"> {`${key}`}</p>
                                                                                <p className="userShippAddressBox-contentBox-lightText">{`${result?.store_timeSchedule[key]}`}</p></div></>)

                                                                        }

                                                                        return (
                                                                            <div className={`userShippAddressBox ${userdata?.shipping_method?.storepick === result?._id ? "active" : ""}`} key={key} 
                                                                            onClick={() => {
                                                                                setUserdata({ ...userdata, shipping_method: { storepick: result?._id } }); setShippingdata((state) => ({
                                                                                    ...state,
                                                                                    shipprice: 0
                                                                                }))
                                                                            }}>
                                                                                <div className="userShippAddressBox-selectBox">
                                                                                    <div className="ecom-radiobtnShowBox">
                                                                                        <input type="radio"
                                                                                            className="ecom-radiobtnShowBox-inputField" id={result?._id} name="selectAdd"
                                                                                            checked={userdata?.shipping_method?.storepick === result?._id} />
                                                                                        <label className="ecom-radiobtnShowBox-labeltext" htmlFor={result?._id}></label>
                                                                                    </div>
                                                                                </div>
                                                                                <div className="userShippAddressBox-imageBox">
                                                                                    <img src={result?.Location_image ? result?.Location_image : DefaultImage} alt="store"/>
                                                                                </div>
                                                                                <div className="userShippAddressBox-contentBox">
                                                                                    <div className="userDetailShipp">
                                                                                        <h3 className="userShippAddressBox-contentBox-boldText">{result?.name}</h3>
                                                                                        <p className="userShippAddressBox-contentBox-paraText">{result?.store_Address}</p>
                                                                                    </div>
                                                                                    <div className="responsive">
                                                                                        <h3 className="userShippAddressBox-contentBox-boldText">{t("Phone number")}:</h3>
                                                                                        <p className="userShippAddressBox-contentBox-lightText">{result?.contacts}</p>
                                                                                    </div>
                                                                                    {/* <div className="d-flex gap-1" >
                                                                                        <h3 className="userShippAddressBox-contentBox-boldText">{t("Store Hours")}</h3>
                                                                                        <p className="userShippAddressBox-contentBox-lightText"></p>
                                                                                    </div> */}
                                                                                    <div className="responsive">
                                                                                        <div className=" shipping-timeSetBox">
                                                                                            {items?.length ? items.map((result) => {
                                                                                                return (result)
                                                                                            }) : ''}
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        )
                                                                    }) : ''}

                                                                </div>

                                                            }
                                                            {errormessage?.shipping_method ? <div className='text-danger'>{t(`${errormessage?.shipping_method}`)}</div> : ""}

                                                        </div> :
                                                        shippingmethod !== undefined ?
                                                            <div className="mt-5">
                                                                <div className="text-danger">{t("You Don’t have a shipping method")}</div>
                                                            </div> : ""
                                                    }
                                                   
                                                    <div className="shipping-addressFromBox-billingAddrBox">
                                                                    {/* {billingaddressfrom ?
                                                                        <div className="com-addressShowBox paymentStepPage-main-paymntAddrBox-addressSetBox">
                                                                            <div className="com-addressShowBox-headerBox">
                                                                                <h3 className="com-addressShowBox-headerBox-heading">
                                                                                    {userdata?.billingaddress?.fname + ' ' + (userdata?.billingaddress?.mname ? userdata?.billingaddress?.mname : '') + ' ' + userdata?.billingaddress?.lname}
                                                                                </h3>
                                                                                <div className="com-addressShowBox-headerBox-iconBox">
                                                                                    <span onClick={() => setBillingaddress(false)}>
                                                                                        <EditIcon />{" "}
                                                                                    </span>
                                                                                </div>
                                                                            </div>
                                                                            <p className="com-addressShowBox-AddrparaBox fixed-widthSet">
                                                                                {userdata?.billingaddress?.address ? userdata?.billingaddress?.address + " " + userdata?.billingaddress?.city + " " + userdata?.billingaddress?.state + " " + userdata?.billingaddress?.zipcode : ""}
                                                                            </p>
                                                                            <p className="com-addressShowBox-phonePara">
                                                                                {userdata?.billingaddress?.contacts?.[0]?.['number'] ?
                                                                                    `(+${userdata?.billingaddress?.contacts?.[0]?.['phoneCode']}) ${userdata?.billingaddress?.contacts?.[0]?.['number']}`
                                                                                    : ''}
                                                                            </p>
                                                                        </div> : */}
                                                                        <div className="shipping-addressFromBox-billingAddrBox-form-header">
                                                                                {t("Billing Address")}
                                                                            </div>
                                                                        {addressdata?.billing_address?.length ? 
                                                                        <div className="shipping-addressFromBox-billingAddrBox-container">
                                                                            <section className="addresscollector">
                                                                            {addressdata?.billing_address?.map((address, i)=>{
                                                                                return(
                                                                                    <div className="addresscollector-individualBox">
                                                                                        <div className="">
                                                                                            <div className="ecom-radiobtnShowBox" onClick={()=> handleSelectAddress(address,i)}>
                                                                                                <input type="radio" className="ecom-radiobtnShowBox-inputField"
                                                                                                    id={i+'billingaddress'} name="billingaddress"
                                                                                                    checked={activeAddress?.billing === i ? true : false}
                                                                                                />
                                                                                                <label className="ecom-radiobtnShowBox-labeltext"
                                                                                                    htmlFor={i+'billingaddress'}></label>
                                                                                            </div>
                                                                                        </div>
                                                                                        <div className="addresscollector-individualBox-inner">
                                                                                            <div className="addresscollector-individualBox-inner-data">
                                                                                                <div className="addresscollector-individualBox-inner-data-title">{address?.name ? address?.name : ""}</div>
                                                                                                <div className="addresscollector-individualBox-inner-data-metadata">{address?.completeAddress ? address?.completeAddress : ''}</div>
                                                                                                <div className="addresscollector-individualBox-inner-data-metadata">{address?.phone ? address?.phone : ''}</div>
                                                                                                <div className="addresscollector-individualBox-inner-data-metadata">{address?.email ? address?.email : ''}</div>
                                                                                                <div className="addresscollector-individualBox-inner-data-metadata">{t("Tax ID")}: {address?.taxId ? address?.taxId : ''}</div>
                                                                                            </div>
                                                                                            <div className="addresscollector-individualBox-inner-actions">
                                                                                                {address?.is_default ?
                                                                                                <div className="addresscollector-individualBox-inner-actions-isdefault">
                                                                                                    <span>{t("Default Billing Address")}</span>
                                                                                                </div>
                                                                                                : null}
                                                                                                <div className="addresscollector-individualBox-inner-actions-edit">
                                                                                                    <span>{t("Edit")}</span>
                                                                                                    <span><EditIcon/></span>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                </div>
                                                                                )
                                                                            })}
                                                                            </section>
                                                                            <div className="shipping-addressFromBox-billingAddrBox-container-description cursor-pointer" onClick={()=>{setAddNewAddress('billing'); setActiveAddress((state)=>({...state, billing : null}))}}>
                                                                                <span><PlusIcon/> </span><span>{t("Add Billing Address")}</span>
                                                                            </div>
                                                                        </div>
                                                                        :  null }
                                                                             {fromshow || addNewAddress === 'billing' || !addressdata?.billing_address?.length ? 
                                                                        <form className="shipping-addressFromBox-billingAddrBox-form">
                                                                            <div className="shipping-addressFromBox-billingAddrBox-form-multifieldRow">
                                                                                <div className="ecom-formInputBox">
                                                                                    <label className={`ecom-formInputBox-label ${userdata?.billingaddress?.fname ? 'active' : ''}`}>
                                                                                        {t("First Name")} <span className="text-danger">*</span>
                                                                                    </label>
                                                                                    <input
                                                                                        className={`ecom-formInputBox-input ${errormessage?.billingfname ? 'border-danger' : ''}`}
                                                                                        value={userdata?.billingaddress?.fname ? userdata?.billingaddress?.fname : ""}
                                                                                        disabled={userdata?.default_billing ? true : false}
                                                                                        onChange={(e) => setUserdata({
                                                                                            ...userdata,
                                                                                            billingaddress: { ...userdata?.billingaddress, fname: e.target.value }
                                                                                        })} />
                                                                                    {errormessage?.billingfname ? <div className='text-danger'>{t(`${errormessage?.billingfname}`)}</div> : ""}
                                                                                </div>
                                                                                <div className="ecom-formInputBox">
                                                                                    <label className={`ecom-formInputBox-label ${userdata?.billingaddress?.lname ? 'active' : ''}`}>
                                                                                        {t("Last Name")} <span className="text-danger">*</span>
                                                                                    </label>
                                                                                    <input
                                                                                        className={`ecom-formInputBox-input ${errormessage?.billinglname ? 'border-danger' : ''}`}
                                                                                        value={userdata?.billingaddress?.lname ? userdata?.billingaddress?.lname : ""}
                                                                                        disabled={userdata?.default_billing ? true : false}
                                                                                        onChange={(e) => setUserdata({
                                                                                            ...userdata,
                                                                                            billingaddress: { ...userdata?.billingaddress, lname: e.target.value }
                                                                                        })} />
                                                                                    {errormessage?.billinglname ? <div className='text-danger'>{t(`${errormessage?.billinglname}`)}</div> : ""}
                                                                                </div>
                                                                            </div>
                                                                            <div className="ecom-formInputBox">
                                                                                <label className={`ecom-formInputBox-label ${userdata?.billingaddress?.company ? "active" : ""}`}>
                                                                                    {t("Company")}<span className="text-danger">*</span>
                                                                                </label>
                                                                                <input
                                                                                    className={errormessage?.billingaddress ? 'ecom-formInputBox-input border-danger' : 'ecom-formInputBox-input'}
                                                                                    value={userdata?.billingaddress?.company ? userdata?.billingaddress?.company : ""}
                                                                                    disabled={userdata?.default_billing ? true : false}
                                                                                    onChange={(e) => setUserdata({
                                                                                        ...userdata,
                                                                                        billingaddress: { ...userdata?.billingaddress, company: e.target.value }
                                                                                    })}
                                                                                    />
                                                                                {errormessage?.billingaddress ? <div className='text-danger'>{t(`${errormessage?.billingaddress}`)}</div> : ""}
                                                                            </div>
                                                                            <div className="ecom-formInputBox">
                                                                                <label className={`ecom-formInputBox-label ${userdata?.billingaddress?.address ? "active" : ""}`}>
                                                                                    {t("Address")}<span className="text-danger">*</span>
                                                                                </label>
                                                                                <input
                                                                                    className={errormessage?.billingaddress ? 'ecom-formInputBox-input border-danger' : 'ecom-formInputBox-input'}
                                                                                    value={userdata?.billingaddress?.address ? userdata?.billingaddress?.address : ""}
                                                                                    disabled={userdata?.default_billing ? true : false}
                                                                                    onChange={(e) => setUserdata({
                                                                                        ...userdata,
                                                                                        billingaddress: { ...userdata?.billingaddress, address: e.target.value }
                                                                                    })}
                                                                                    />
                                                                                {errormessage?.billingaddress ? <div className='text-danger'>{t(`${errormessage?.billingaddress}`)}</div> : ""}
                                                                            </div>
                                                                            <div className="shipping-addressFromBox-billingAddrBox-form-multifieldRow">
                                                                                <div className="ecom-formInputBox">
                                                                                    <label className={`ecom-formInputBox-dropdownlabel ${userdata?.billingaddress?.country ? "active" : ""}`}>
                                                                                        {t("Country")} <span className="text-danger">*</span>
                                                                                    </label>
                                                                                    <Select
                                                                                        options={countrylist}
                                                                                        className={`${errormessage?.billingcountry ? "border-danger" : ""}`}
                                                                                        height='46px'
                                                                                        width='100%'
                                                                                        value={userdata?.billingaddress?.country || null}
                                                                                        onChange={(e) => setUserdata({
                                                                                            ...userdata,
                                                                                            billingaddress: { ...userdata?.billingaddress, country: e }
                                                                                        })}
                                                                                        isSearchable={false}
                                                                                        classNamePrefix='newDropdown'
                                                                                    />
                                                                                    {errormessage?.billingcountry ? <div className='text-danger'>{t(`${errormessage?.billingcountry}`)}</div> : ""}
                                                                                </div>
                                                                                <div className="ecom-formInputBox">
                                                                                    <label className={`ecom-formInputBox-label ${userdata?.billingaddress?.state ? "active" : ""}`}>
                                                                                        {t("Province/State")} <span className="text-danger">*</span>
                                                                                    </label>
                                                                                    <input
                                                                                        className={errormessage?.billingstate ? 'ecom-formInputBox-input border-danger' : 'ecom-formInputBox-input'}
                                                                                        value={userdata?.billingaddress?.state ? userdata?.billingaddress?.state : ""}
                                                                                        disabled={userdata?.default_billing ? true : false}
                                                                                        onChange={(e) => setUserdata({
                                                                                            ...userdata,
                                                                                            billingaddress: { ...userdata?.billingaddress, state: e.target.value }
                                                                                        })} />
                                                                                    {errormessage?.billingstate ? <div className='text-danger'>{t(`${errormessage?.billingstate}`)}</div> : ""}
                                                                                </div>
                                                                            </div>
                                                                            <div className="shipping-addressFromBox-billingAddrBox-form-multifieldRow">
                                                                                <div className='ecom-formInputBox'>
                                                                                    <label className={`ecom-formInputBox-label ${userdata?.billingaddress?.city ? "active" : ""}`}>{t("City")} <span className='text-danger'>*</span></label>
                                                                                    <input
                                                                                        className={errormessage?.billingcity ? 'ecom-formInputBox-input border-danger' : 'ecom-formInputBox-input'}
                                                                                        value={userdata?.billingaddress?.city ? userdata?.billingaddress?.city : ""}
                                                                                        disabled={userdata?.default_billing ? true : false}
                                                                                        onChange={(e) => setUserdata({
                                                                                            ...userdata,
                                                                                            billingaddress: { ...userdata?.billingaddress, city: e.target.value }
                                                                                        })} />
                                                                                    {errormessage?.billingcity ? <div className='text-danger'>{t(`${errormessage?.billingcity}`)}</div> : ""}
                                                                                </div>
                                                                                <div className='ecom-formInputBox'>
                                                                                    <label className={`ecom-formInputBox-label ${userdata?.billingaddress?.zipcode ? "active" : ""}`}>{t("Zip Code")} <span className='text-danger'>*</span></label>
                                                                                    <input
                                                                                       className={errormessage?.billingzipcode ? 'ecom-formInputBox-input border-danger' : 'ecom-formInputBox-input'}
                                                                                        value={userdata?.billingaddress?.zipcode ? userdata?.billingaddress?.zipcode : ""}
                                                                                        disabled={userdata?.default_billing ? true : false}
                                                                                        onChange={(e) =>
                                                                                            setUserdata({
                                                                                                ...userdata,
                                                                                                billingaddress: { ...userdata?.billingaddress, zipcode: e.target.value }
                                                                                            })} />
                                                                                    {errormessage?.billingzipcode ? <div className='text-danger'>{t(`${errormessage?.billingzipcode}`)}</div> : ""}
                                                                                </div>
                                                                            </div>
                                                                            <div className="ecom-formInputBox">
                                                                                <label className={`ecom-formInputBox-label ${userdata?.billingaddress?.taxId ? "active" : ""}`}>
                                                                                    {t("Tax ID No")}. {t("Optional)")}
                                                                                </label>
                                                                                <input
                                                                                    className={errormessage?.billingaddress ? 'ecom-formInputBox-input border-danger' : 'ecom-formInputBox-input'}
                                                                                    value={userdata?.billingaddress?.taxId ? userdata?.billingaddress?.taxId : ""}
                                                                                    disabled={userdata?.default_billing ? true : false}
                                                                                    onChange={(e) => setUserdata({
                                                                                        ...userdata,
                                                                                        billingaddress: { ...userdata?.billingaddress, taxId: e.target.value }
                                                                                    })}
                                                                                    />
                                                                                {errormessage?.billingaddress ? <div className='text-danger'>{t(`${errormessage?.billingaddress}`)}</div> : ""}
                                                                            </div>
                                                                            <div className="shipping-addressFromBox-billingAddrBox-form-multifieldRow">
                                                                                <div className="shipping-addressFromBox-billingAddrBox-form-multifieldRow-addons">
                                                                                        {userdata?.billingaddress?.contacts?.length ? userdata?.billingaddress?.contacts.map((result, key) => {
                                                                                            return (
                                                                                                <div className={errormessage?.billingcontacts ? 'ecom-formInputBox-phontfieldinput border-danger' : 'ecom-formInputBox-phontfieldinput'}>
                                                                                                <div className='ecom-formInputBox' key={key}>
                                                                                                    
                                                                                                        <div
                                                                                                            className={`ecom-formInputBox-phontfield ${errormessage?.billingcontacts ? 'border-danger d-flex' : "d-flex"}`}
                                                                                                            
                                                                                                        >
                                                                                                             <label className={`ecom-formInputBox-label ${userdata?.billingaddress?.contacts?.length ? "active" : ""}`}>{t("Contact")} <span className='text-danger'>*</span></label>
                                                                                                            <div className='selectError_border w-15 border-0 t3-drop-down'>
                                                                                                                <Select
                                                                                                                    options={phonecodelist}
                                                                                                                    className={``}
                                                                                                                    classNamePrefix='newDropdown'
                                                                                                                    value={{ 'label': result?.phoneCode, 'value': result?.phoneCode }}
                                                                                                                    onChange={(e) => ChangeMultipleSelect(e?.value, key, 'contacts', result?.number,false)
                                                                                                                        // setUserdata({
                                                                                                                        //     ...userdata,
                                                                                                                        //     billingaddress: { ...userdata?.billingaddress, contacts: [{ icon: 1, phoneCode: e.value, number: result?.number }] }
                                                                                                                        // })
                                                                                                                        }
                                                                                                                />
                                                                                                            </div>
                                                                                                                    <input
                                                                                                                        type='number'
                                                                                                                        className='numberfield'
                                                                                                                        value={result?.number}
                                                                                                                        onChange={(e) => ChangeMultipleSelect(result?.phoneCode, key, 'contacts', e.target.value,false)
                                                                                                                            // setUserdata({
                                                                                                                            //     ...userdata,
                                                                                                                            //     billingaddress: { ...userdata?.billingaddress, contacts: [{ icon: 1, phoneCode: result?.phoneCode, number: e.target.value }] }
                                                                                                                            // })
                                                                                                                        }
                                                                                                                    />

                                                                                                            {key !== 0 ? <span className="ecom-formInputBox-cancelIcon" onClick={()=> RemoveBlock('contacts', key,false)}><MinusIcon/></span> : ""}
                                                                                                        </div>
                                                                                                        </div>
                                                                                                         </div>
                                                                                            )
                                                                                        }) : ''}
                                                                                        {errormessage?.billingcontacts ? <div className='text-danger'>{t(`${errormessage?.billingcontacts}`)}</div> : ""}
                                                                                        
                                                                                   
                                                                                    
                                                                                    
                                                                                    <div className="shipping-addressFromBox-billingAddrBox-form-multifieldRow-addons-row" 
                                                                                            onClick={(e) => AddRow('contacts',false)
                                                                                                                            // setUserdata({
                                                                                                                            //     ...userdata,
                                                                                                                            //     billingaddress: { ...userdata?.billingaddress, contacts: [...userdata?.billingaddress?.contacts, { icon: 1, phoneCode: "" , number: "" }] }
                                                                                                                            // })
                                                                                                                            }>
                                                                                           <span><PlusIcon/></span>  <span>{t("Add Phone Number")}</span>
                                                                                    </div>
                                                                                </div>
                                                                                <div className='ecom-formInputBox'>
                                                                                    <label className={`ecom-formInputBox-label ${userdata?.billingaddress?.emails[0] ? "active" : ""}`}>{t("Email")} <span className='text-danger'>*</span></label>
                                                                                    <input
                                                                                        className={errormessage?.billingemails ? 'ecom-formInputBox-input border-danger' : 'ecom-formInputBox-input'}
                                                                                        value={userdata?.billingaddress?.emails[0] ? userdata?.billingaddress?.emails[0] : ""}
                                                                                        disabled={userdata?.default_billing ? true : false}
                                                                                        onChange={(e) => setUserdata({
                                                                                            ...userdata,
                                                                                            billingaddress: { ...userdata?.billingaddress, emails: [e.target.value] }
                                                                                        })} />
                                                                                    {errormessage?.billingemails ? <div className='text-danger'>{t(`${errormessage?.billingemails}`)}</div> : ""}
                                                                                </div>
                                                                            </div>
                                                                        </form>
                                                                        : null}
                                                                    {/* } */}

                                                                </div>


                                                            {!addressdata?.shipping_address?.length && changeshipping  ? 
                                                                <div className="shipping-addressFromBox-copyBox">
                                                                                    <div className="ecom-radiobtnShowBox" >
                                                                                        <input type="radio" className="ecom-radiobtnShowBox-inputField"
                                                                                            id="copybillingaddress" name="shiphome"
                                                                                            onChange={CopyBillingAddresstoShippingAddress}
                                                                                        />
                                                                                        <label className="ecom-radiobtnShowBox-labeltext"
                                                                                            htmlFor="copybillingaddress"></label>
                                                                                    </div>
                                                                                    <div className="shipping-addressFromBox-copyBox-text">{t("Copy Billing Address to Shipping Address")}</div>
                                                                </div>
                                                                : null }


                                                                {/* first tab shipping section */}
                                                                {changeshipping ?
                                                                <>
                                                                <div className="shipping-addressFromBox-headBox d-flex">
                                                                    <h3 className="shipping-addressFromBox-billingAddrBox-form-header">{t("Shipping Address")}</h3>
                                                                    {/* {accessToken && !userdata?.default_billing ?
                                                                        <div className=" mt-2 w-100 text-end cursor-pointer" data-bs-toggle="modal" data-bs-target="#shiipingAddrmodal"
                                                                            onClick={() => setShipaddress((state) => ({
                                                                                ...state,
                                                                                ship: true,
                                                                                billing: false
                                                                            }))}>{t("Change Shipping Address")}</div>
                                                                        : ""} */}
                                                                </div>
                                                                {addressdata?.shipping_address?.length ? 
                                                                <div className="shipping-addressFromBox-billingAddrBox-container">
                                                                <section className="addresscollector">
                                                                {addressdata?.shipping_address?.map((address, i)=>{
                                                                    return(
                                                                        <div className="addresscollector-individualBox">
                                                                            <div className="">
                                                                                <div className="ecom-radiobtnShowBox" onClick={()=>{getFullAddress(address?.UDID,false); setActiveAddress((state)=>({...state, shipping: i}))}}>
                                                                                    <input type="radio" className="ecom-radiobtnShowBox-inputField"
                                                                                        id={i+'shippingaddress'} name="shiphome"
                                                                                        checked={activeAddress?.shipping === i ? true : false}
                                                                                    />
                                                                                    <label className="ecom-radiobtnShowBox-labeltext"
                                                                                        htmlFor={i+'shippingaddress'}></label>
                                                                                </div>
                                                                            </div>
                                                                            <div className="addresscollector-individualBox-inner">
                                                                                <div className="addresscollector-individualBox-inner-data">
                                                                                    <div className="addresscollector-individualBox-inner-data-title">{address?.name ? address?.name : ""}</div>
                                                                                    <div className="addresscollector-individualBox-inner-data-metadata">{address?.completeAddress ? address?.completeAddress : ''}</div>
                                                                                    <div className="addresscollector-individualBox-inner-data-metadata">{address?.phone ? address?.phone : ''}</div>
                                                                                    <div className="addresscollector-individualBox-inner-data-metadata">{address?.email ? address?.email : ''}</div>
                                                                                    <div className="addresscollector-individualBox-inner-data-metadata">{t("Tax ID")}: {address?.taxId ? address?.taxId : ''}</div>
                                                                                </div>
                                                                                <div className="addresscollector-individualBox-inner-actions">
                                                                                    {address?.is_default ?
                                                                                    <div className="addresscollector-individualBox-inner-actions-isdefault">
                                                                                        <span>{t("Default Billing Address")}</span>
                                                                                    </div>
                                                                                    : null}
                                                                                    <div className="addresscollector-individualBox-inner-actions-edit">
                                                                                        <span>{t("Edit")}</span>
                                                                                        <span><EditIcon/></span>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                    </div>
                                                                    )
                                                                })}
                                                                </section>
                                                                <div className="shipping-addressFromBox-billingAddrBox-container-description cursor-pointer" onClick={()=>{setAddNewAddress('shipping'); setActiveAddress((state)=>({...state, shipping : null}))}}>
                                                                    <span><PlusIcon/> </span><span>{t("Add Shipping Address")}</span>
                                                                </div>
                                                            </div>
                                                                :  null }    
                                                                <>                                                         
                                                                {fromshow || addNewAddress === 'shipping' || !addressdata?.shipping_address?.length ?
                                                                    <div className='addAdressBox-formBody'>
                                                                        <div className='addAdressBox-formBody-stepfirst'>
                                                                            <div className='addAdressBox-formBody-nameBox'>
                                                                          
                                                                                <div className='ecom-formInputBox'>
                                                                                    <label className={`ecom-formInputBox-label ${userdata?.shipping_address?.fname ? 'active' : ''}`}>{t("First Name")} <span className='text-danger'>*</span></label>
                                                                                    <input
                                                                                        className={`ecom-formInputBox-input ${errormessage?.fname ? 'border-danger' : ''}`}
                                                                                        value={userdata?.shipping_address?.fname}
                                                                                        onChange={(e) => setUserdata({
                                                                                            ...userdata,
                                                                                            shipping_address: {
                                                                                                ...userdata?.shipping_address,
                                                                                                fname: e.target.value
                                                                                            }
                                                                                        })} />
                                                                                    {errormessage?.fname ? <div className='text-danger'>{t(`${errormessage?.fname}`)}</div> : ""}
                                                                                </div>
                                                                                {/* <div className='ecom-formInputBox'>
                                                                                    <label className=''>{t("Middle Name")}</label>
                                                                                    <input
                                                                                        className='form-control'
                                                                                        value={userdata?.shipping_address?.mname}
                                                                                        onChange={(e) => setUserdata({
                                                                                            ...userdata,
                                                                                            shipping_address: {
                                                                                                ...userdata?.shipping_address,
                                                                                                mname: e.target.value
                                                                                            }
                                                                                        })} />
                                                                                </div> */}
                                                                                <div className='ecom-formInputBox'>
                                                                                    <label className={`ecom-formInputBox-label ${userdata?.shipping_address?.lname ? 'active' : ''}`}>{t("Last Name")} <span className='text-danger'>*</span></label>
                                                                                    <input
                                                                                        className={`ecom-formInputBox-input ${errormessage?.lname ? 'border-danger' : ''}`}
                                                                                        value={userdata?.shipping_address?.lname}
                                                                                        onChange={(e) => setUserdata({
                                                                                            ...userdata,
                                                                                            shipping_address: {
                                                                                                ...userdata?.shipping_address,
                                                                                                lname: e.target.value
                                                                                            }
                                                                                        })} />
                                                                                    {errormessage?.lname ? <div className='text-danger'>{t(`${errormessage?.lname}`)}</div> : ""}
                                                                                </div>
                                                                            </div>
                                                                            <div className='ecom-formInputBox'>
                                                                                    <label className={`ecom-formInputBox-label ${userdata?.shipping_address?.company ? 'active' : ''}`}>{t("Company")} <span className='text-danger'>*</span></label>
                                                                                    <input
                                                                                     className={`ecom-formInputBox-input ${errormessage?.company ? 'border-danger' : ''}`}
                                                                                        value={userdata?.shipping_address?.company}
                                                                                        onChange={(e) => setUserdata({
                                                                                            ...userdata,
                                                                                            shipping_address: {
                                                                                                ...userdata?.shipping_address,
                                                                                                company: e.target.value
                                                                                            }
                                                                                        })} />
                                                                                    {errormessage?.company ? <div className='text-danger'>{t(`${errormessage?.company}`)}</div> : ""}
                                                                                </div>
                                                                            <div className='addAdressBox-formBody-nameBox'>
                                                                                <div className='ecom-formInputBox'>
                                                                                    <label className={`ecom-formInputBox-label ${userdata?.shipping_address?.address ? 'active' : ''}`}>{t("Address")} <span className='text-danger'>*</span></label>
                                                                                    <input
                                                                                        className={`ecom-formInputBox-input ${errormessage?.address ? 'border-danger' : ''}`}
                                                                                        value={userdata?.shipping_address?.address}
                                                                                        onChange={(e) => setUserdata({
                                                                                            ...userdata,
                                                                                            shipping_address: {
                                                                                                ...userdata?.shipping_address,
                                                                                                address: e.target.value
                                                                                            }
                                                                                        })} />
                                                                                    {errormessage?.address ? <div className='text-danger'>{t(`${errormessage?.address}`)}</div> : ""}
                                                                                </div>
                                                                            </div>
                                                                            <div className='addAdressBox-formBody-nameBox fullscreen-select'>
                                                                                <div className='ecom-formInputBox'>

                                                                                    <label className={`ecom-formInputBox-dropdownlabel ${userdata?.shipping_address?.country ? 'active' : ''}`}>{t("Country")} <span className='text-danger'>*</span></label>
                                                                                    <div className={errormessage?.country ? 'selectError_border border-danger' : 'selectError_border'
                                                                                    }
                                                                                    >
                                                                                        <Select
                                                                                            className={`${errormessage?.country ? 'border-danger' : ''}`}
                                                                                            options={countrylist}
                                                                                            value={userdata?.shipping_address?.country}
                                                                                            onChange={(e) => setUserdata({
                                                                                                ...userdata,
                                                                                                shipping_address: {
                                                                                                    ...userdata?.shipping_address,
                                                                                                    country: e
                                                                                                }
                                                                                            })}
                                                                                            classNamePrefix="newDropdown"
                                                                                            isSearchable={widtth > 560 ? true : false}
                                                                                        />
                                                                                    </div>
                                                                                    {errormessage?.country ? <div className='text-danger'>{t(`${errormessage?.country}`)}</div> : ""}
                                                                                </div>
                                                                               
                                                                                <div className='ecom-formInputBox'>
                                                                                    <label className={`ecom-formInputBox-label ${userdata?.shipping_address?.state ? 'active' : ''}`}>{t("Province/State")} <span className='text-danger'>*</span></label>
                                                                                    <input
                                                                                     className={`ecom-formInputBox-input ${errormessage?.state ? 'border-danger' : ''}`}
                                                                                        value={userdata?.shipping_address?.state}
                                                                                        onChange={(e) => setUserdata({
                                                                                            ...userdata,
                                                                                            shipping_address: {
                                                                                                ...userdata?.shipping_address,
                                                                                                state: e.target.value
                                                                                            }
                                                                                        })} />
                                                                                    {errormessage?.state ? <div className='text-danger'>{t(`${errormessage?.state}`)}</div> : ""}
                                                                                </div>
                                                                            </div>
                                                                            <div className='addAdressBox-formBody-nameBox'>
                                                                                <div className='ecom-formInputBox'>
                                                                                    <label className={`ecom-formInputBox-label ${userdata?.shipping_address?.city ? 'active' : ''}`}>{t("City")} <span className='text-danger'>*</span></label>
                                                                                    <input
                                                                                        className={`ecom-formInputBox-input ${errormessage?.city ? 'border-danger' : ''}`}
                                                                                        value={userdata?.shipping_address?.city}
                                                                                        onChange={(e) => setUserdata({
                                                                                            ...userdata,
                                                                                            shipping_address: {
                                                                                                ...userdata?.shipping_address,
                                                                                                city: e.target.value
                                                                                            }
                                                                                        })} />
                                                                                    {errormessage?.city ? <div className='text-danger'>{t(`${errormessage?.city}`)}</div> : ""}
                                                                                </div>
                                                                                <div className='ecom-formInputBox'>
                                                                                    <label className={`ecom-formInputBox-label ${userdata?.shipping_address?.zipcode ? 'active' : ''}`}>{t("Zip Code")} <span className='text-danger'>*</span></label>
                                                                                    <input
                                                                                        className={`ecom-formInputBox-input ${errormessage?.zipcode ? 'border-danger' : ''}`}
                                                                                        value={userdata?.shipping_address?.zipcode}
                                                                                        onChange={(e) => setUserdata({
                                                                                            ...userdata,
                                                                                            shipping_address: {
                                                                                                ...userdata?.shipping_address,
                                                                                                zipcode: e.target.value
                                                                                            }
                                                                                        })} />
                                                                                    {errormessage?.zipcode ? <div className='text-danger'>{t(`${errormessage?.zipcode}`)}</div> : ""}
                                                                                </div>
                                                                            </div>
                                                                            <div className='addAdressBox-formBody-nameBox'>
                                                                                <div className='ecom-formInputBox'>
                                                                                    <label className={`ecom-formInputBox-label ${userdata?.shipping_address?.taxId ? 'active' : ''}`}>{t("Tax ID no. (optional)")}</label>
                                                                                    <input
                                                                                        className={`ecom-formInputBox-input ${errormessage?.taxId ? 'border-danger' : ''}`}
                                                                                        value={userdata?.shipping_address?.taxId}
                                                                                        onChange={(e) => setUserdata({
                                                                                            ...userdata,
                                                                                            shipping_address: {
                                                                                                ...userdata?.shipping_address,
                                                                                                taxId: e.target.value
                                                                                            }
                                                                                        })} />
                                                                                    {errormessage?.taxId ? <div className='text-danger'>{t(`${errormessage?.taxId}`)}</div> : ""}
                                                                                </div>
                                                                            </div>
                                                                            <div className='addAdressBox-formBody-nameBox align-items-start'>
                                                                                {/* <div className='ecom-formInputBox'>
                                                                                    <label className=''>{t("Contact")} <span className='text-danger'>*</span></label>
                                                                                    <div className='form-phoneAddContainer'>
                                                                                        {userdata?.shipping_address?.contacts?.length ? userdata?.shipping_address?.contacts.map((result, key) => {
                                                                                            return (
                                                                                                <>


                                                                                                    <div className="d-flex align-items-start w-100" key={key}>
                                                                                                        <div
                                                                                                            // className={errormessage?.contacts ? 'formBox-withMinusBtn border-danger' : 'formBox-withMinusBtn '}
                                                                                                            className={errormessage?.contacts ? 'd-flex align-items-start border border-danger rounded w-100' : "d-flex align-items-start border rounded w-100"}
                                                                                                        >
                                                                                                            <div className='selectError_border w-50 border-0'>
                                                                                                                <Select
                                                                                                                    options={phonecodelist}
                                                                                                                    className="ecommerce-dropdown w-100"
                                                                                                                    classNamePrefix="common-select"
                                                                                                                    value={{ 'label': result?.phoneCode, 'value': result?.phoneCode }}
                                                                                                                    onChange={(e) => ChangeMultipleSelect(e?.value, key, 'contacts', result?.number)}
                                                                                                                />
                                                                                                            </div>
                                                                                                            <div className="d-grid w-100">

                                                                                                                <div className="d-flex align-items-center">
                                                                                                                    <input
                                                                                                                        type='number'
                                                                                                                        className='form-control border-0'
                                                                                                                        value={result?.number}
                                                                                                                        onChange={(e) => ChangeMultipleSelect(result?.phoneCode, key, 'contacts', e.target.value)}
                                                                                                                    />
                                                                                                                </div>


                                                                                                            </div>
                                                                                                        </div>
                                                                                                        {key !== 0 ? <span className='formBox-withMinusBtn-removebtn handleIcon ms-2 mt-2' onClick={() => RemoveBlock('contacts', key)}><MinusIcon /></span> : ''}
                                                                                                    </div>
                                                                                                    {errormessage?.contacts ? <div className='text-danger'>{t(`${errormessage?.contacts}`)}</div> : ""}
                                                                                                </>
                                                                                            )
                                                                                        }) : ''}

                                                                                        <div className='com-addFormItem-box'>
                                                                                            <div className='com-addFormItem-box-inner' onClick={() => AddRow('contacts')}>
                                                                                                <span className='d-flex'><PlusIcon width={16} height={16} color={'#1CACAC'} /></span>
                                                                                                {t("Add contacts")}
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div> */}
                                                                                <div className="shipping-addressFromBox-billingAddrBox-form-multifieldRow-addons">
                                                                                    {userdata?.shipping_address?.contacts?.length ? userdata?.shipping_address?.contacts.map((result, key) => {
                                                                                            return (
                                                                                                <div className={errormessage?.contacts  ? 'ecom-formInputBox-phontfieldinput border-danger' : 'ecom-formInputBox-phontfieldinput'}>
                                                                                                <div className='ecom-formInputBox' key={key}>
                                                                                                    
                                                                                                        <div
                                                                                                            className={`ecom-formInputBox-phontfield ${errormessage?.contacts  ? 'border-danger d-flex' : "d-flex"}`}
                                                                                                            
                                                                                                        >
                                                                                                             <label className={`ecom-formInputBox-label ${userdata?.shipping_address?.contacts?.length ? "active" : ""}`}>{t("Contact")} <span className='text-danger'>*</span></label>
                                                                                                            <div className='selectError_border w-10 border-0 t3-drop-down' style={{maxWidth:'fit-content'}}>
                                                                                                                <Select
                                                                                                                    options={phonecodelist}
                                                                                                                    className={``}
                                                                                                                    classNamePrefix='newDropdown'
                                                                                                                    value={{ 'label': result?.phoneCode, 'value': result?.phoneCode }}
                                                                                                                    onChange={(e) => ChangeMultipleSelect(e?.value, key, 'contacts', result?.number)}
                                                                                                                />
                                                                                                            </div>
                                                                                                                    <input
                                                                                                                        type='number'
                                                                                                                        className='numberfield'
                                                                                                                        value={result?.number}
                                                                                                                        onChange={(e) => ChangeMultipleSelect(result?.phoneCode, key, 'contacts', e.target.value)}
                                                                                                                    />

                                                                                                            {key !== 0 ? <span className="ecom-formInputBox-cancelIcon"  onClick={() => RemoveBlock('contacts', key)}><MinusIcon/></span> : ""}
                                                                                                        </div>
                                                                                                        </div>
                                                                                                         </div>
                                                                                            )
                                                                                        }) : ''}
                                                                                        {errormessage?.contacts ? <div className='text-danger'>{t(`${errormessage?.contacts}`)}</div> : ""}
                                                                                        
                                                                                   
                                                                                    
                                                                                    
                                                                                    <div className="shipping-addressFromBox-billingAddrBox-form-multifieldRow-addons-row" 
                                                                                          onClick={() => AddRow('contacts')}>
                                                                                           <span><PlusIcon/></span>  <span>{t("Add Phone Number")}</span>
                                                                                    </div>
                                                                                </div>
                                                                                {/* <div className='ecom-formInputBox'>
                                                                                    <label className=''>{t("Email")} <span className='text-danger'>*</span></label>
                                                                                    <div className='form-phoneAddContainer'>
                                                                                        {userdata?.shipping_address?.emails?.length ? userdata?.shipping_address?.emails?.map((result, key) => {
                                                                                            return (
                                                                                                <>
                                                                                                    <div className='formBox-withMinusBtn border-0' key={key}>
                                                                                                        <input
                                                                                                            className={errormessage?.emails ? 'form-control border-danger' : 'form-control'}
                                                                                                            value={result} onChange={(e) => ChangeMultipleSelect(e.target.value, key, 'email', '')} />

                                                                                                        {key !== 0 ? <span className='formBox-withMinusBtn-removebtn handleIcon' onClick={() => RemoveBlock('email', key)}><MinusIcon /></span> : ''}
                                                                                                    </div>
                                                                                                    {errormessage?.emails ? <div className='text-danger'>{t(`${errormessage?.emails}`)}</div> : ""}
                                                                                                </>
                                                                                            );
                                                                                        }) : ''}

                                                                                        <div className='com-addFormItem-box'>
                                                                                            <div className='com-addFormItem-box-inner' onClick={() => AddRow('email')}>
                                                                                                <span className='d-flex'><PlusIcon width={16} height={16} color={'#1CACAC'} /></span>
                                                                                                {t("Add Email")}
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div> */}
                                                                                <div className="shipping-addressFromBox-billingAddrBox-form-multifieldRow-addons">
                                                                                {userdata?.shipping_address?.emails?.length ? userdata?.shipping_address?.emails?.map((result, key) => {
                                                                                            return (
                                                                                                <div className={errormessage?.emails  ? 'ecom-formInputBox-phontfieldinput border-danger' : 'ecom-formInputBox-phontfieldinput'}>
                                                                                                <div className='ecom-formInputBox' key={key}>
                                                                                                    
                                                                                                        <div
                                                                                                            className={`ecom-formInputBox-phontfield ${errormessage?.emails  ? 'border-danger d-flex' : "d-flex"}`}
                                                                                                            
                                                                                                        >
                                                                                                             <label className={`ecom-formInputBox-label ${userdata?.shipping_address?.emails?.length ? "active" : ""}`}>{t("Email")} <span className='text-danger'>*</span></label>
                                                                                                            
                                                                                                                    <input
                                                                                                                        type='email'
                                                                                                                        className='numberfield'
                                                                                                                        value={result} onChange={(e) => ChangeMultipleSelect(e.target.value, key, 'email', '')}
                                                                                                                    />

                                                                                                            {key !== 0 ? <span className="ecom-formInputBox-cancelIcon"  onClick={() => RemoveBlock('email', key)}><MinusIcon/></span> : ""}
                                                                                                        </div>
                                                                                                        </div>
                                                                                                         </div>
                                                                                            )
                                                                                        }) : ''}
                                                                                        {errormessage?.emails ? <div className='text-danger'>{t(`${errormessage?.emails}`)}</div> : ""}
                                                                                        
                                                                                   
                                                                                    
                                                                                    
                                                                                    <div className="shipping-addressFromBox-billingAddrBox-form-multifieldRow-addons-row" 
                                                                                          onClick={() => AddRow('email')}>
                                                                                           <span><PlusIcon/></span>  <span>{t("Add Email")}</span>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            <div className="addAdressBox-formBody-radioSwitchBox">
                                                                                {/* <p className="addAdressBox-formBody-radioSwitchBox-textShow">{t("Default Shipping Address")}</p>
                                                                                <div className="com-customToggleCheck">
                                                                                    <input type="checkbox" id="togglebtn1" className="com-customToggleCheck-toogleInput"
                                                                                        defaultChecked={userdata?.shipping_address?.is_default ? true : false}
                                                                                        onChange={(e) => setUserdata((state) => ({
                                                                                            ...userdata,
                                                                                            shipping_address: {
                                                                                                ...userdata?.shipping_address, is_default: e.target.checked ? 1 : 0
                                                                                            }
                                                                                        }))} />
                                                                                    <label htmlFor="togglebtn1" className="com-customToggleCheck-toggleLabel"></label>
                                                                                </div> */}
                                                                                <div className="ecom-darkthemed-checkbox ecom-checkbox-wrapper">
                                                                                    <input
                                                                                    type="checkbox"
                                                                                    id="makeDefault"
                                                                                    onChange={() => setBillingaddressdata((state)=>({...state, is_default: billingaddressdata.is_default === 1 ? 0 : 1}))}
                                                                                    checked={billingaddressdata?.is_default === 1 ? true : false}
                                                                                    />
                                                                                    <label htmlFor="makeDefault" className="ecom-darkthemed-checkbox-label">
                                                                                    </label>
                                                                                    <span className={`mobilefilter-inner-wrapper-content-filterdata-holder-label`}>{t("Save Billing address and Shipping address to default")}</span>
                                                                                </div>
                                                                            </div>
                                                                            {/* <div className='addAdressBox-formBody-nameBox'>

                                                                                <div className='ecom-formInputBox'>
                                                                                    <label className=''>{t("Nationality")} <span className='text-danger'>*</span></label>
                                                                                    <div className={errormessage?.nationality ? 'selectError_border border-danger' : 'selectError_border'
                                                                                    }
                                                                                    >
                                                                                        <Select
                                                                                            name='nationality'
                                                                                            value={{ label: userdata?.shipping_address?.nationality, value: userdata?.shipping_address?.nationality }}
                                                                                            onChange={(e) => setUserdata({
                                                                                                ...userdata,
                                                                                                shipping_address: {
                                                                                                    ...userdata?.shipping_address,
                                                                                                    nationality: e.value
                                                                                                }
                                                                                            })}
                                                                                            options={nationalityoption}
                                                                                            className="ecommerce-dropdown"
                                                                                            components={{
                                                                                                ValueContainer: CustomValueContainer,
                                                                                            }}
                                                                                            placeholder={t("Nationality")}
                                                                                            menuPlacement="auto"
                                                                                            classNamePrefix="common-select"
                                                                                            getOptionLabel={(opt) => opt.label}
                                                                                            isSearchable={true}
                                                                                        />
                                                                                    </div>
                                                                                    {errormessage?.nationality ? <div className='text-danger'>{t(`${errormessage?.nationality}`)}</div> : ""}
                                                                                </div>

                                                                                <div className='ecom-formInputBox'>
                                                                                    <label className=''>{t("Title")}<span className='text-danger'>*</span></label>
                                                                                    <div className={errormessage?.title ? 'selectError_border border-danger' : 'selectError_border'
                                                                                    }
                                                                                    >
                                                                                        <Select
                                                                                            value={{ label: userdata?.shipping_address.title, value: userdata?.shipping_address.title }}
                                                                                            onChange={(e) => setUserdata({
                                                                                                ...userdata,
                                                                                                shipping_address: {
                                                                                                    ...userdata?.shipping_address,
                                                                                                    title: e.value
                                                                                                }
                                                                                            })}
                                                                                            className="ecommerce-dropdown"
                                                                                            placeholder={t("Title")}
                                                                                            options={titleoption}
                                                                                            components={{
                                                                                                ValueContainer: CustomValueContainer,
                                                                                            }}
                                                                                            menuPlacement="auto"
                                                                                            classNamePrefix="common-select"
                                                                                            getOptionLabel={(e) => (
                                                                                                <div className="">
                                                                                                    <span>{e.label}</span>
                                                                                                </div>
                                                                                            )}
                                                                                            isSearchable={false}
                                                                                        />
                                                                                    </div>
                                                                                    {errormessage?.title ? <div className='text-danger'>{t(`${errormessage?.title}`)}</div> : ""}
                                                                                </div>
                                                                            </div> */}
                                                                        </div>
                                                                        {/* <div className='addAdressBox-formBody-stepfirst pt-0'>
                                                                            {userdata?.shipping_address?.govt_ids?.length ? userdata?.shipping_address?.govt_ids.map((result, key) => {
                                                                                return (
                                                                                    <div className='addAdressBox-formBody-nameBox' key={key}>
                                                                                        <div className='ecom-formInputBox'>
                                                                                            <label className=''>{t("ID")} <span className='text-danger'>*</span></label>
                                                                                            <div className={errormessage?.govt_ids ? 'selectError_border     border-danger' : 'selectError_border'
                                                                                            }
                                                                                            >
                                                                                                <Select
                                                                                                    className='ecommerce-dropdown'
                                                                                                    options={idProofOption}
                                                                                                    classNamePrefix="common-select"
                                                                                                    value={{ label: result?.idtype, value: result?.idtype }}
                                                                                                    onChange={(e) => ChangeMultipleSelect(e?.value, key, 'govt_ids', result?.idnumber)}
                                                                                                />
                                                                                            </div>
                                                                                        </div>
                                                                                        <div className='ecom-formInputBox'>
                                                                                            <label className=''>{t("ID Number")} <span className='text-danger'>*</span></label>
                                                                                            <div className='formBox-withMinusBtn border-0 d-grid'>
                                                                                                <div className="d-flex align-items-center w-100">
                                                                                                    <input
                                                                                                        className={errormessage?.govt_ids ? 'form-control border-danger' : 'form-control'
                                                                                                        }
                                                                                                        value={result?.idnumber}
                                                                                                        onChange={(e) => ChangeMultipleSelect(result?.idtype, key, 'govt_ids', e.target.value)} />
                                                                                                    {key !== 0 ? <span className='formBox-withMinusBtn-removebtn handleIcon ms-2' onClick={() => RemoveBlock('govt_ids', key)}><MinusIcon /></span> : ''}

                                                                                                </div>
                                                                                                {errormessage?.govt_ids ? <div className='text-danger'>{t(`${errormessage?.govt_ids}`)}</div> : ""}
                                                                                            </div>
                                                                                        </div>

                                                                                    </div>
                                                                                )
                                                                            }) : ''}

                                                                            <div className='com-addFormItem-box'>
                                                                                <div className='com-addFormItem-box-inner' onClick={(e) => AddRow('govt_ids')}>
                                                                                    <span className='d-flex'><PlusIcon width={16} height={16} color={'#1CACAC'} /></span>
                                                                                    {t("Add ID")}
                                                                                </div>
                                                                            </div>
                                                                            <div className='addAdressBox-formBody-nameBox'>
                                                                                <div className='ecom-formInputBox'>
                                                                                    <label className=''>{t("Birthdate (Date, Month, Year)")} <span className='text-danger'>*</span></label>

                                                                                    <div className="birthday-calendarBox">
                                                                                        <div className="birthday-calendarBox-inner col-md-4 col-sm-12 col-3">
                                                                                            <div className={errormessage?.date_of_birth ? 'selectError_border border-danger' : 'selectError_border'}
                                                                                            >
                                                                                                <Select
                                                                                                    className="ecommerce-dropdown withrtlfix"
                                                                                                    placeholder=""
                                                                                                    options={dobvalues?.date}
                                                                                                    value={{ value: userdata?.shipping_address?.date_of_birth?.date, label: userdata?.shipping_address?.date_of_birth?.date }}
                                                                                                    onChange={(e) => setUserdata((state) => ({
                                                                                                        ...state,
                                                                                                        shipping_address: {
                                                                                                            ...state?.shipping_address,
                                                                                                            date_of_birth: {
                                                                                                                ...state?.shipping_address?.date_of_birth,
                                                                                                                date: e.value
                                                                                                            }
                                                                                                        }
                                                                                                    }))}
                                                                                                    classNamePrefix="common-select"
                                                                                                    isSearchable={false}
                                                                                                />
                                                                                            </div>
                                                                                        </div>

                                                                                        <div className="birthday-calendarBox-inner col-md-4 col-sm-12 col-3">
                                                                                            <div className={errormessage?.date_of_birth ? 'selectError_border border-danger' : 'selectError_border'}
                                                                                            >
                                                                                                <Select
                                                                                                    className="ecommerce-dropdown withrtlfix"
                                                                                                    placeholder=""
                                                                                                    options={dobvalues?.month}
                                                                                                    value={userdata?.shipping_address?.date_of_birth?.month || null}
                                                                                                    onChange={(e) => setUserdata((state) => ({
                                                                                                        ...state,
                                                                                                        shipping_address: {
                                                                                                            ...state?.shipping_address,
                                                                                                            date_of_birth: {
                                                                                                                ...state?.shipping_address?.date_of_birth,
                                                                                                                month: e
                                                                                                            }
                                                                                                        }
                                                                                                    }))}
                                                                                                    classNamePrefix="common-select"
                                                                                                    isSearchable={false}
                                                                                                />
                                                                                            </div>
                                                                                        </div>
                                                                                        <div className="birthday-calendarBox-inner col-md-4 col-sm-12 col-3">
                                                                                            <div className={errormessage?.date_of_birth ? 'selectError_border border-danger' : 'selectError_border'}
                                                                                            >
                                                                                                <Select
                                                                                                    className="ecommerce-dropdown withrtlfix"
                                                                                                    placeholder=""
                                                                                                    options={dobvalues?.year}
                                                                                                    value={{
                                                                                                        value: userdata?.shipping_address?.date_of_birth?.year,
                                                                                                        label: userdata?.shipping_address?.date_of_birth?.year
                                                                                                    }}
                                                                                                    onChange={(e) => {
                                                                                                        setUserdata((state) => ({
                                                                                                            ...state,
                                                                                                            shipping_address: {
                                                                                                                ...state?.shipping_address,
                                                                                                                date_of_birth: {
                                                                                                                    ...state?.shipping_address?.date_of_birth,
                                                                                                                    year: e.value
                                                                                                                }
                                                                                                            }
                                                                                                        }));
                                                                                                        callAge(e);
                                                                                                    }}
                                                                                                    classNamePrefix="common-select"
                                                                                                    isSearchable={false}
                                                                                                />
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>


                                                                                    {errormessage?.date_of_birth ? <div className='text-danger'>{t(`${errormessage?.date_of_birth}`)}</div> : ""}
                                                                                </div>
                                                                                <div className='ecom-formInputBox'>
                                                                                    <label className=''>{t("Age")} <span className='text-danger'>*</span></label>
                                                                                    <input
                                                                                        disabled
                                                                                        className={errormessage?.age ? 'form-control border-danger' : 'form-control'}
                                                                                        value={userdata?.shipping_address?.age}
                                                                                        onChange={(e) => setUserdata({
                                                                                            ...userdata,
                                                                                            shipping_address: {
                                                                                                ...userdata?.shipping_address,
                                                                                                age: e.target.value
                                                                                            }
                                                                                        })} />
                                                                                    {errormessage?.age ? <div className='text-danger'>{t(`${errormessage?.age}`)}</div> : ""}
                                                                                </div>
                                                                            </div>
                                                                            <div className='gender-checkBox'>
                                                                                <div className='ecom-formInputBox'>
                                                                                    <label className=''>{t("Gender")}<span className='text-danger'>*</span></label>
                                                                                </div>
                                                                                <div className='gender-checkBox-checkContainer d-block'>
                                                                                    <div className="d-flex w-100">
                                                                                        {gender.map((result, key) => {
                                                                                            return (
                                                                                                <div className='gender-checkBox-checkContainer-singleCheck' key={key}>
                                                                                                    <input type="radio" id={result} checked={userdata?.shipping_address?.gender === result ? true : false} name="gender" value={result} onChange={(e) => setUserdata({
                                                                                                        ...userdata,
                                                                                                        shipping_address: {
                                                                                                            ...userdata?.shipping_address,
                                                                                                            gender: e.target.value
                                                                                                        }
                                                                                                    })} />
                                                                                                    <label htmlFor={result}>{t(`${result}`)}</label>
                                                                                                </div>
                                                                                            )
                                                                                        })}
                                                                                    </div>
                                                                                    {errormessage?.gender ? <div className='text-danger'>{t(`${errormessage?.gender}`)}</div> : ""}
                                                                                </div>
                                                                            </div>
                                                                        </div> */}
                                                                        {/* <div className='addAdressBox-formBody-stepfirst pt-0 mb-0'>
                                                                            <h3 className='contact-header-box'>{t("Contact")}</h3>
                                                                        
                                                                            
                                                                            
                                                                        
                                                                        

                                                                        </div> */}
                                                                    </div> 
                                                                    :
                                                                    // <div className="shipping-addressFromBox paymentStepPage-main-paymntAddrBox">
                                                                    //     <div className="com-addressShowBox paymentStepPage-main-paymntAddrBox-addressSetBox">
                                                                    //         <div className="com-addressShowBox-headerBox">
                                                                    //             <h3 className="com-addressShowBox-headerBox-heading">
                                                                    //                 {userdata?.shipping_address?.fname + ' ' + (userdata?.shipping_address?.mname ? userdata?.shipping_address?.mname : '') + ' ' + userdata?.shipping_address?.lname}
                                                                    //             </h3>
                                                                    //             <div className="com-addressShowBox-headerBox-iconBox" >
                                                                    //                 <span onClick={() => { setFromshow(true) }}>
                                                                    //                     <EditIcon />{" "}
                                                                    //                 </span>
                                                                    //             </div>
                                                                    //         </div>
                                                                    //         <p className="com-addressShowBox-AddrparaBox fixed-widthSet">
                                                                    //             {userdata?.shipping_address?.address ? userdata?.shipping_address?.address + " " + userdata?.shipping_address?.city + " " + userdata?.shipping_address?.state + " " + userdata?.shipping_address?.zipcode : ""}
                                                                    //         </p>
                                                                    //         <p className="com-addressShowBox-phonePara">
                                                                    //             {userdata?.shipping_address?.contacts?.[0]?.['number'] ?
                                                                    //                 `(+${userdata?.shipping_address?.contacts?.[0]?.['phoneCode']}) ${userdata?.shipping_address?.contacts?.[0]?.['number']}`
                                                                    //                 : ''}
                                                                    //         </p>
                                                                    //     </div>
                                                                    // </div>
                                                                    null
                                                                }
                                                                </>
                                                                </> : null }
                                                 
                                                </div>

                                                {/* bottom content of first section */}

                                                
                                                <div className="ecom-darkthemed-checkbox ecom-checkbox-wrapper">
                                                    <input
                                                    type="checkbox"
                                                    id="privacy-policy"
                                                    onChange={() =>  handlePrivacyPolicy()}
                                                    checked={privacyPolicy ? true : false}
                                                    />
                                                    <label htmlFor="privacy-policy" className="ecom-darkthemed-checkbox-label">
                                                    </label>
                                                    <span className={`mobilefilter-inner-wrapper-content-filterdata-holder-label ${errormessage?.privacyPolicy ? 'text-danger' : ''}`}>{t("I accept the")}{" "}<span className="text-decoration-underline" onClick={()=> navigate('/page/privacy-policy')}>{t("Privacy Policy")}</span>{" "}{t("and")}{" "}<span onClick={()=> navigate('/page/terms-and-conditions')}>{t("Terms and conditions")}</span>.</span>
                                                </div>
                                                <div className="shipping-formBottom-btn">
                                                    <div className='shipping-formBottom-btn-backCartBtnBox'><span className='arrowIconCart'><LeftSideArrowIcon width={16.71} height={16.71} /></span >
                                                        <Link className="text-decoration-none" to="/shoppingcart" state={{ shippingdata: shippinglist }}><span className='cartBackShow'>{t("Return to cart")}</span></Link></div>
                                                    <button type="button" className='btnbold'
                                                        onClick={() => validationfun(userdata)}>{t("Continue")}</button>
                                                </div>
                                            </fieldset> 
                                            // end of first tab
                                            
                                            :
                                            fromstaps?.two ?
                                                <fieldset className="shipping-step-mainForm-Container-fieldsetBox">
                                                    <div className="paymentStepPage">
                                                        <div className="shipping-addressFromBox paymentStepPage-main">
                                                            {/* <div className="shipping-addressFromBox paymentStepPage-main-paymntAddrBox">
                                                                <h3 className="com-shippingPage-headingMain m-0">{t("Shipping Address")}</h3>
                                                                <div className="com-addressShowBox paymentStepPage-main-paymntAddrBox-addressSetBox">
                                                                    <div className="com-addressShowBox-headerBox">
                                                                        <h3 className="com-addressShowBox-headerBox-heading">
                                                                            {userdata?.shipping_address?.fname + ' ' + (userdata?.shipping_address?.mname ? userdata?.shipping_address?.mname : '') + ' ' + userdata?.shipping_address?.lname}
                                                                        </h3>
                                                                        <div className="com-addressShowBox-headerBox-iconBox" >
                                                                            <span onClick={() => { setFromstaps({ one: true, two: false, three: false }); setFromshow(true) }} >
                                                                                <EditIcon />{" "}
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                    <p className="com-addressShowBox-AddrparaBox fixed-widthSet">
                                                                        {userdata?.shipping_address?.address ? userdata?.shipping_address?.address + " " + userdata?.shipping_address?.city + " " + userdata?.shipping_address?.state + " " + userdata?.shipping_address?.zipcode : ""}
                                                                    </p>
                                                                    <p className="com-addressShowBox-phonePara">
                                                                        {userdata?.shipping_address?.contacts?.[0]?.['number'] ?
                                                                            `(+${userdata?.shipping_address?.contacts?.[0]?.['phoneCode']}) ${userdata?.shipping_address?.contacts?.[0]?.['number']}`
                                                                            : ''}
                                                                    </p>
                                                                </div>
                                                            </div> */}
                                                            <div className="paymentStepPage-main-paymentMethodBox">
                                                                <div className="paymentStepPage-main-paymentMethodBox-headBox">
                                                                <h3 className="com-shippingPage-headingMain mb-2 w-100">{t("Payment Method")} ({t("Select 1 option")})</h3>
                                                                    {/* <div className="conditionPriv-checkBox m-0">
                                                                        <div className="com-ecomCheckBox">
                                                                            <input
                                                                                value={userdata?.default_billing}
                                                                                type="checkbox"
                                                                                className=" com-ecomCheckBox-inputcheck me-2 cursor-pointer"
                                                                                id="AddrCondition"
                                                                                onChange={(e) => ChangeCheck('default_billing', e)}
                                                                            />
                                                                            <label
                                                                                className="com-ecomCheckBox-labelBox cursor-pointer fw-semibold"
                                                                                htmlFor="AddrCondition"
                                                                            >
                                                                                {t("Billing address same as shipping details")}.
                                                                            </label>
                                                                        </div>
                                                                    </div> */}
                                                                </div>
                                                                {/* {accessToken && !userdata?.default_billing ?
                                                                    <div className="text-end">
                                                                        <span
                                                                            className="cursor-pointer"
                                                                            data-bs-toggle="modal" data-bs-target="#shiipingAddrmodal"
                                                                            onClick={() => setShipaddress((state) => ({
                                                                                ...state,
                                                                                billing: true,
                                                                                ship: false
                                                                            }))}>{t("Change Billing Address")}</span>
                                                                    </div>
                                                                    : ""} */}
                                                               
                                                            </div>
                                                            {paymentgetwaydata?.length ?
                                                                <div className="paymentStepPage-main-paymentMethodBox">
                                                                    <PaymentTabs
                                                                        userdata={userdata}
                                                                        setUserdata={setUserdata}
                                                                        paymentgetwaydata={paymentgetwaydata}
                                                                        payamount={shippingdata?.shipprice ? shippingdata?.shipprice + shippinglist.reduce(
                                                                            (accumulator, product) => accumulator + product.UnFormatPrice * product?.qty,
                                                                            0
                                                                        ) : 0 + shippinglist.reduce(
                                                                            (accumulator, product) => accumulator + product.UnFormatPrice * product?.qty,
                                                                            0
                                                                        )}
                                                                        currency={shippingdata?.CURRENCY}
                                                                        setCreditpaymentdata={setCreditpaymentdata}
                                                                        creditpaymentdata={creditpaymentdata}
                                                                        alldata={{
                                                                            name: userdata?.billingaddress?.fname,
                                                                            email: userdata?.billingaddress?.emails[0]
                                                                        }} />

                                                                    {errormessage?.payment || creditpaymentdata?.message ? <div className="text-danger">
                                                                        {errormessage?.payment ? errormessage?.payment :
                                                                            creditpaymentdata?.message}</div> :
                                                                        ""}
                                                                </div> :
                                                                <div className="text-danger">
                                                                    {t("No payment method available. please contact with support team")}
                                                                </div>
                                                            }

                                                            <div className="">
                                                                <div className="ecom-darkthemed-checkbox ecom-checkbox-wrapper">
                                                                    <input
                                                                    type="checkbox"
                                                                    id="conditioAgree"
                                                                    onChange={(e) => ChangeCheck('agree', e)}
                                                                    checked={userdata?.agree ? true : false}
                                                                    />
                                                                    <label htmlFor="conditioAgree" className="ecom-darkthemed-checkbox-label">
                                                                    </label>
                                                                    <span className={`mobilefilter-inner-wrapper-content-filterdata-holder-label ${errormessage?.privacyPolicy ? 'text-danger' : ''}`}>{t("I accept the")}{" "}<span className="text-decoration-underline">{t("Privacy Policy")}</span>{" "}{t("and")}{" "}<span className="text-decoration-underline">{t("Terms and conditions")}</span>.</span>
                                                                </div>
                                                                {/* <div className="com-ecomCheckBox">
                                                                    <input type="checkbox" checked={userdata?.agree ? true : false} onChange={(e) => ChangeCheck('agree', e)} className=" com-ecomCheckBox-inputcheck me-2 cursor-pointer" id="conditioAgree" />
                                                                    <label className="com-ecomCheckBox-labelBox cursor-pointer fw-semibold" htmlFor="conditioAgree">{t("I agree to the terms and conditions and the privacy policy")}</label>
                                                                </div> */}
                                                                {errormessage?.privacy ? <div className="text-danger">{t(`${errormessage?.privacy}`)}</div> : ""}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {errormessage?.ordererror ? <div className="text-danger text-end">{t(`${errormessage?.ordererror}`)}</div> : ""}
                                                    <button type="button" className=' d-none com-ecomSendBtn shipping-continBtn previous' id="previous_btn" name="previous" value="Previous">{t("Pervious")}</button>
                                                    <div className="shipping-formBottom-btn">
                                                        <div className='shipping-formBottom-btn-backCartBtnBox'><span className='arrowIconCart'><LeftSideArrowIcon width={16.71} height={16.71} /></span ><span className='cartBackShow'
                                                            onClick={() => setFromstaps({ one: true, two: false, three: false })} >
                                                            {t("Back")}</span></div>
                                                        {lodaer ?
                                                            <div className='com-ecomSendBtn shipping-continBtn next'>
                                                                <div className="border-bottom-0 border-width-2px text-white d-block mx-auto spinner-border flex-shrink-0" role="status"></div>
                                                            </div> :
                                                            <button type="button" className='btnbold' name="next" value="Next" id='firststep_2'
                                                                onClick={() =>validationfunsecound(userdata)}>{t("Continue")}</button>}
                                                    </div>
                                                </fieldset> :

                                                <fieldset className="shipping-step-mainForm-Container-fieldsetBox">
                                                    <div className="confirmPurchasePage">
                                                        <ConfirmPage creditpaymentdata={creditpaymentdata}  shippingdata={shippingdata} shippinglist={shippinglist} lastpagedata={lastpagedata} countrylist={countrylist} />
                                                    </div>

                                                </fieldset>
                                        }


                                    </div>
                                </div>
                            </form>
                           
                                <div className="shippingpage-bothSideBox-rightSide">
                                    <div className={`hiddentab ${isOpenOrder ? 'open' : 'bg-white'}`} onClick={toggleOrderSummary}>
                                        <div className="hiddentab-leftside">
                                            <CheckoutBucketIcon/>
                                            <div>
                                            {toFormatPrice(shippinglist?.length ?
                                                shippingdata?.shipprice ? shippingdata?.shipprice + shippinglist.reduce(
                                                    (accumulator, product) => accumulator + product.UnFormatPrice * product?.qty,
                                                    0
                                                ) : shippinglist.reduce(
                                                    (accumulator, product) => accumulator + product.UnFormatPrice * product?.qty,
                                                    0
                                                ) : 0 + 0, { addSymbol: true })}
                                            </div>
                                        </div>
                                        <div className="hiddentab-rightside">
                                            <span className='hiddentab-contentText'>{t("View Order Summary")}</span>
                                            <span className="hiddentab-rightside-arrow"><DownArrow/></span>
                                        </div>
                                    </div>
                                    <div id="shippingOrderSumm" className={isOpenOrder ? 'active' : ''}>
                                        <OrderSummery  fromstaps={fromstaps} shippinglist={shippinglist} setShippinglist={setShippinglist} shippingdata={shippingdata} />
                                    </div>
                                </div> 
                        </div>
                    </>
                    :
                    <>
                        {navigate("/shoppingcart", { state: { shippingdata: [] } })}
                    </>}

            </div>
            {/* <ShippingAddrModel
                shipaddress={shipaddress}
                setShipaddress={setShipaddress}
                setUserdata={setUserdata}
                setFromshow={setFromshow}
                setBillingaddress={setBillingaddress}
                dobvalues={dobvalues} /> */}

        </>
  )
}
